import React, { useState, useEffect, useMemo, useRef, useCallback } from "react";
import {
  Button,
  Upload,
  message,
  Menu,
  Dropdown,
  Row,
  Col,
  Image,
  Skeleton,
  Checkbox,
  Modal,
  Typography,
  Input,
  Form,
  Space,
  Radio,
  Card,
  Tooltip,
  Switch,
} from "antd";
import {
  ArrowLeftOutlined,
  FileTextOutlined,
  EllipsisOutlined,
  DeleteOutlined,
  EditOutlined,
  CaretDownOutlined,
  DownloadOutlined,
  ArrowUpOutlined,
  ArrowDownOutlined,
  DragOutlined,
  CheckOutlined,
  CloseOutlined,
  PlusCircleOutlined,
  PlusOutlined,
  LayoutOutlined,
  NumberOutlined,
  VideoCameraOutlined,
  PictureOutlined,
  PlayCircleOutlined,
  PlayCircleFilled,
  FieldTimeOutlined,
  ShareAltOutlined,
  CopyOutlined,
  LoadingOutlined,
  MailOutlined,
  FacebookOutlined,
  EyeOutlined,
  LinkOutlined,
  CalendarOutlined,
  OrderedListOutlined,
  InfoCircleOutlined,
  ReloadOutlined,
  InboxOutlined,
  UndoOutlined,
  HistoryOutlined,
  FilePdfOutlined,
} from "@ant-design/icons";
import { LuRefreshCcw } from "react-icons/lu";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { useDispatch, useSelector } from "react-redux";
import {
  getProject,
  deleteProject,
  deleteProjectImage,
  getProjectTrashImages,
  getProjectImage,
  batchReorderImages,
  duplicateProjectImage,
  archiveProject,
  unarchiveProject,
  uploadProjectDocument,
} from "../../services/projectServices";
import { createReport, getProjectReports, getLayoutOptions, updateReportShareSettings } from "../../services/reportsService";
import ShareReportModal from "./reports/modals/ShareReportModal";
import ButtonBar from "../../components/ButtonNavigation";
import ImageEditorModal from "./ImageEditorModal";
import FDCamPreviewModal from "./FDCamPreviewModal";
import ProjectHistoryDrawer from "./modals/ProjectHistoryDrawer";
import ProjectTrashModal from "./modals/ProjectTrashModal";
import ProjectDocuments from "./ProjectDocuments";
import ProjectDocumentUploadModal from "./modals/ProjectDocumentUploadModal";
import { updateProjectImage } from "../../services/projectServices";
import axios from "axios";
import placeholderIMage from "../../assets/images/project-placeholder-image.jpg";
import { DndProvider } from "react-dnd";
import { LARAVEL_BACKEND_API_URL, MEDIA_UPLOAD_URL_VIDEO } from "../../Helper";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import { HTML5Backend } from "react-dnd-html5-backend";
import {
  DndContext,
  closestCenter,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
  DragOverlay,
} from "@dnd-kit/core";
import {
  arrayMove,
  SortableContext,
  sortableKeyboardCoordinates,
  rectSortingStrategy,
  useSortable,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

const parseDateBadgeInfo = (dateStr) => {
  if (!dateStr) return null;
  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return null;
  return {
    month: d.toLocaleDateString('en-US', { month: 'short' }),
    day: d.getDate(),
    year: d.getFullYear(),
  };
};

const SortableProjectImageCard = ({
  image,
  index,
  reorderMode,
  selectedForReorder,
  onToggleReorderSelect,
  selectedImages,
  handleCheckboxChange,
  disabledImages,
  handleCopyImage,
  copyingImageId,
  handleEditImage,
  handleShareClick,
  editingDescriptionId,
  setEditingDescriptionId,
  descriptionValue,
  setDescriptionValue,
  handleChangedescription,
  showDateBadge,
  getShortDate,
  onImagePreviewClick,
}) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id: image.id,
    disabled: !reorderMode,
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.3 : 1,
  };

  return (
    <Col
      className="single-project-date-image"
      key={image.id}
      xs={12}
      sm={8}
      md={6}
      lg={4}
    >
      <div
        ref={setNodeRef}
        style={{
          ...style,
          cursor: reorderMode ? 'move' : 'default',
        }}
        className={`project-detail-image-card ${reorderMode ? 'reorder-mode' : ''} ${selectedForReorder.includes(image.id) ? 'selected-for-reorder' : ''}`}
        {...(reorderMode ? attributes : {})}
        {...(reorderMode ? listeners : {})}
      >
        {reorderMode && (
          <>
            <div className="drag-handle" title="Drag to reorder">
              <DragOutlined style={{ fontSize: '13px' }} />
            </div>
            {selectedForReorder.includes(image.id) ? (
              <div
                className="selection-badge selected"
                title="Click to deselect"
                onClick={(e) => {
                  e.stopPropagation();
                  onToggleReorderSelect(image.id);
                }}
              >
                {selectedForReorder.indexOf(image.id) + 1}
              </div>
            ) : (
              <div
                className="selection-badge unselected"
                title="Click to select for batch move"
                onClick={(e) => {
                  e.stopPropagation();
                  onToggleReorderSelect(image.id);
                }}
              >
                <PlusOutlined style={{ fontSize: '11px' }} />
              </div>
            )}
          </>
        )}
        {!reorderMode && (
          <Checkbox
            style={{ position: 'absolute', top: '10px', left: '10px', zIndex: 10 }}
            className="custom-checkbox-style"
            checked={selectedImages?.includes(image?.id)}
            disabled={disabledImages.includes(image.id)}
            onChange={(e) =>
              handleCheckboxChange([{ id: image?.id }], e.target.checked)
            }
          />
        )}
        <div style={{ position: 'relative', borderRadius: '8px', overflow: 'hidden' }}>
          <Image
            src={image.image}
            alt={`Image ${index + 1}`}
            className="object-cover image-date-project"
            preview={!reorderMode ? {
              visible: false,
              onVisibleChange: (visible) => {
                if (visible && onImagePreviewClick) {
                  onImagePreviewClick(image);
                }
              }
            } : false}
            style={{ cursor: reorderMode ? 'move' : 'pointer' }}
          />
          {showDateBadge && image.created_at && (() => {
            const dateInfo = parseDateBadgeInfo(image.created_at);
            if (!dateInfo) return null;
            return (
              <div className="photo-date-gradient-overlay">
                <CalendarOutlined className="photo-date-icon" />
                <span className="photo-date-text">
                  <span className="photo-date-month-day">{dateInfo.month} {dateInfo.day}</span>
                  <span className="photo-date-comma">, </span>
                  <span className="photo-date-year">{dateInfo.year}</span>
                </span>
              </div>
            );
          })()}
        </div>
        {!reorderMode && (
          <div className="edit-button-wrapper" style={{ display: 'flex', gap: '8px' }}>
            <Button
              disabled={disabledImages.includes(image.id) || copyingImageId === image.id}
              icon={copyingImageId === image.id ? <LoadingOutlined /> : <CopyOutlined />}
              onClick={(e) => {
                e.stopPropagation();
                if (handleCopyImage) {
                  handleCopyImage(image);
                }
              }}
              ghost
              title="Copy Photo (Clean Original with Description)"
              style={{ color: '#fff' }}
            />
            <Button
              disabled={disabledImages.includes(image.id)}
              icon={<EditOutlined />}
              onClick={() => handleEditImage(image)}
              ghost
              style={{ color: '#fff' }}
            />
            <Button
              disabled={disabledImages.includes(image.id)}
              icon={<ShareAltOutlined />}
              onClick={() => handleShareClick('photo', image)}
              ghost
              style={{ color: '#fff' }}
            />
          </div>
        )}
        <div className="project-detail-image-description">
          {editingDescriptionId === image.id ? (
            <Input.TextArea
              style={{ border: "1px solid #75bdff" }}
              rows={4}
              value={descriptionValue}
              autoFocus
              onChange={(e) => setDescriptionValue(e.target.value)}
              onBlur={() => {
                handleChangedescription(descriptionValue, image.description, image.id);
                setEditingDescriptionId(null);
              }}
              onKeyDown={(e) => {
                if (e.key === "Escape") setEditingDescriptionId(null);
              }}
            />
          ) : (
            <Input.TextArea
              style={{
                border: "1px solid #edecec",
                padding: "4px 4px",
                borderRadius: "2px",
                cursor: "pointer",
              }}
              disabled={disabledImages.includes(image.id)}
              onClick={() => {
                if (!disabledImages.includes(image.id)) {
                  setEditingDescriptionId(image.id);
                  setDescriptionValue(image.description || "");
                }
              }}
              rows={2}
              value={image.description || "Click to add a description"}
            />
          )}
        </div>
      </div>
    </Col>
  );
};

const ProjectDetail = () => {
  const userDetails = useSelector(state => state.User?.userDetails);
  const [isCopied, setIsCopied] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [videoFileList, setVideoFileList] = useState([]);
  const [uploadDocModalVisible, setUploadDocModalVisible] = useState(false);
  const [uploadVideoCount, setUploadVideoCount] = useState(0);
  const [maxVideoOrderIndex, setMaxVideoOrderIndex] = useState(0);
  const { Paragraph } = Typography;
  const [project, setProject] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [historyDrawerVisible, setHistoryDrawerVisible] = useState(false);
  const [editorVisible, setEditorVisible] = useState(false);
  const [imageId, setImageId] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedOriginalUrl, setSelectedOriginalUrl] = useState(null);
  const [selectedAnnotations, setSelectedAnnotations] = useState(null);
  const [selectedImages, setSelectedImages] = useState([]);
  const [dateImages, setDateImages] = useState([]);
  const [uploadCount, setUploadCount] = useState(0);
  const [disabledImages, setDisabledImages] = useState([]);
  const [maxOrderIndex, setMaxOrderIndex] = useState(0);
  const [sortOrder, setSortOrder] = useState("asc"); // 'desc' for newest first, 'asc' for oldest first
  const [editingDescriptionId, setEditingDescriptionId] = useState(null);
  const [descriptionValue, setDescriptionValue] = useState("");
  const [editingVideoDescriptionId, setEditingVideoDescriptionId] = useState(null);
  const [videoDescriptionValue, setVideoDescriptionValue] = useState("");
  const [reorderMode, setReorderMode] = useState(false);
  const [activeDragItem, setActiveDragItem] = useState(null);
  const [selectedForReorder, setSelectedForReorder] = useState([]);
  const [hasReorderChanges, setHasReorderChanges] = useState(false);
  const [isSavingOrder, setIsSavingOrder] = useState(false);
  const [switchedFromDateMode, setSwitchedFromDateMode] = useState(false);
  const [copyingImageId, setCopyingImageId] = useState(null);

  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 5,
      },
    }),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  );

  const handleToggleReorderSelect = (imgId) => {
    setSelectedForReorder(prev =>
      prev.includes(imgId) ? prev.filter(id => id !== imgId) : [...prev, imgId]
    );
  };
  const [galleryViewMode, setGalleryViewMode] = useState('index'); // 'index' (Custom Order) | 'date' (Group by Date)
  const [flatImagesList, setFlatImagesList] = useState([]);
  const [reportModalVisible, setReportModalVisible] = useState(false);
  const [reportTitle, setReportTitle] = useState("");
  const [photosPerPage, setPhotosPerPage] = useState(2);
  const [showReports, setShowReports] = useState(false);
  const [projectReports, setProjectReports] = useState([]);
  const [layoutOptions, setLayoutOptions] = useState([]);
  const [creatingReport, setCreatingReport] = useState(false);
  const [reportsTotal, setReportsTotal] = useState(0);
  const [loadingMoreReports, setLoadingMoreReports] = useState(false);
  const [claimNumber, setClaimNumber] = useState("");

  const [projectVideos, setProjectVideos] = useState([]);
  const [loadingVideos, setLoadingVideos] = useState(false);
  const [videosTotal, setVideosTotal] = useState(0);
  const [uploadView, setUploadView] = useState('photos'); // 'photos' | 'videos' | 'documents'
  const [videoModalVisible, setVideoModalVisible] = useState(false);
  const [currentVideo, setCurrentVideo] = useState(null);

  const [projectDocuments, setProjectDocuments] = useState([]);
  const [documentsTotal, setDocumentsTotal] = useState(0);
  const [showDocuments, setShowDocuments] = useState(false);

  // FDCam Preview Modal States
  const [fdcamPreviewVisible, setFdcamPreviewVisible] = useState(false);
  const [fdcamMediaList, setFdcamMediaList] = useState([]);
  const [fdcamInitialIndex, setFdcamInitialIndex] = useState(0);
  const [fdcamMediaType, setFdcamMediaType] = useState('image');

  // Project Trash Modal States
  const [trashModalVisible, setTrashModalVisible] = useState(false);
  const [trashCount, setTrashCount] = useState(0);

  // Share Modal State for media
  const [shareModalVisible, setShareModalVisible] = useState(false);
  const [includeDetails, setIncludeDetails] = useState(false);
  const [shareData, setShareData] = useState({ type: '', url: '', id: '', title: '', mediaUrl: '' });

  // Share Modal State for reports
  const [reportShareModalVisible, setReportShareModalVisible] = useState(false);
  const [selectedReportToShare, setSelectedReportToShare] = useState(null);
  const [syncingReportToken, setSyncingReportToken] = useState(false);

  const generateReportShareToken = () => {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for (let i = 0; i < 12; i++) {
      result += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return result;
  };

  const handleOpenReportShare = async (reportObj) => {
    setSelectedReportToShare(reportObj);
    setReportShareModalVisible(true);

    if (!reportObj.share_token) {
      setSyncingReportToken(true);
      const newToken = generateReportShareToken();
      try {
        await dispatch(updateReportShareSettings(reportObj.id, {
          share_token: newToken,
          share_token_expires_at: null
        }));
        setSelectedReportToShare({ ...reportObj, share_token: newToken });
        setProjectReports(prev => prev.map(r => r.id === reportObj.id ? { ...r, share_token: newToken } : r));
      } catch (err) {
        console.error(err);
        message.error("Link sync failed. Please try 'Generate New Link'.");
      } finally {
        setSyncingReportToken(false);
      }
    }
  };

  const getTimeAgo = (uploadDate) => {
    const now = new Date();
    const uploaded = new Date(uploadDate);
    const diffInMs = now - uploaded;
    const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));

    if (diffInDays === 0) return 'Today';
    if (diffInDays === 1) return '1 day ago';
    if (diffInDays < 7) return `${diffInDays} days ago`;
    if (diffInDays < 30) return `${Math.floor(diffInDays / 7)} week${Math.floor(diffInDays / 7) > 1 ? 's' : ''} ago`;
    if (diffInDays < 365) return `${Math.floor(diffInDays / 30)} month${Math.floor(diffInDays / 30) > 1 ? 's' : ''} ago`;
    return `${Math.floor(diffInDays / 365)} year${Math.floor(diffInDays / 365) > 1 ? 's' : ''} ago`;
  };

  const getVideoDuration = (videoElement) => {
    const duration = videoElement.duration;
    if (!duration || isNaN(duration)) return null;
    const minutes = Math.floor(duration / 60);
    const seconds = Math.floor(duration % 60);
    return `${minutes}:${seconds.toString().padStart(2, '0')}`;
  };

  const handleVideoPlay = (video) => {
    const index = projectVideos.findIndex((v) => v.id === video.id);
    setFdcamMediaList(projectVideos);
    setFdcamInitialIndex(index >= 0 ? index : 0);
    setFdcamMediaType('video');
    setFdcamPreviewVisible(true);
  };

  // Reorder mode styles are maintained in _base.scss


  const queryParams = new URLSearchParams(window.location.search);
  const project_id = queryParams.get("project_id");
  const dispatch = useDispatch();

  const [avatarShape] = useState("circle");
  const navigate = useNavigate();

  const sortedObject = useMemo(() => {
    const getDateTimestamp = (dateKey) => {
      const firstImg = dateImages[dateKey]?.[0];
      if (firstImg?.created_at) {
        const t = new Date(firstImg.created_at).getTime();
        if (!isNaN(t)) return t;
      }
      const cleaned = String(dateKey).replace(/(\d+)(st|nd|rd|th)/, '$1');
      const t = new Date(cleaned).getTime();
      return isNaN(t) ? 0 : t;
    };

    return Object.keys(dateImages)
      .sort((a, b) => {
        const timeA = getDateTimestamp(a);
        const timeB = getDateTimestamp(b);
        return sortOrder === "desc" ? timeB - timeA : timeA - timeB;
      })
      .reduce((obj, key) => {
        obj[key] = dateImages[key];
        return obj;
      }, {});
  }, [dateImages, sortOrder]);

  const totalImagesCount = useMemo(() => {
    return Object.values(dateImages).reduce((sum, images) => sum + images.length, 0);
  }, [dateImages]);

  const restructureData = (data) => {
    const result = {};
    if (!data || !Array.isArray(data)) return result;

    // Sort by order_index according to the current sortOrder
    const sorted = [...data].sort((a, b) => {
      const aIdx = a.order_index || 0;
      const bIdx = b.order_index || 0;
      return sortOrder === "desc"
        ? bIdx - aIdx // For descending order (newest first)
        : aIdx - bIdx; // For ascending order (oldest first)
    });

    sorted.forEach((item) => {
      if (!item?.created_at) return;
      const date = new Date(item.created_at);
      const dayOfWeek = date.toLocaleString("default", { weekday: "long" });
      const monthName = date.toLocaleString("default", { month: "long" });
      const day = date.getDate();
      const year = date.getFullYear();
      const formattedDate = `${dayOfWeek}, ${monthName} ${day}${getDaySuffix(
        day
      )}, ${year}`;

      if (!result[formattedDate]) {
        result[formattedDate] = [];
      }
      result[formattedDate].push({
        ...item,
        id: item?.id,
        image: (item.image || item.image_url) ? `${(item.image || item.image_url)}${(item.image || item.image_url).includes('?') ? '&' : '?'}cb=${item.updated_at ? new Date(item.updated_at).getTime() : Date.now()}` : '',
        description: item?.description,
        order_index: item?.order_index || 0,
        created_at: item.created_at, // Add created_at so FDCamPreviewModal can use it
        Image
      });
    });

    return result;
  };

  const getSecureId = (id, allowDetails = false) => {
    // Tamper-proof obfuscation: binds allowDetails permission to mathematical verification checksum
    const secret = "fdf"; // FD-Project-Share
    const detailsFlag = allowDetails ? 1 : 0;
    const verification = (Number(id) * 7) + (detailsFlag * 13) + 1234;
    const encoded = window.btoa(`${secret}-${id}-${detailsFlag}-${verification}`);
    return encoded.replace(/=/g, ''); // Remove padding for cleaner URL
  };

  const handleShareClick = async (type, media) => {
    const baseUrl = window.location.origin;
    const rawMediaId = media.id;
    const secureId = getSecureId(rawMediaId, false);
    const mediaUrl = type === 'photo' ? media.image : (media.source_url || media.document_url || media.url);

    // Reset toggle for each new share action
    setIncludeDetails(false);

    // Get company logo and org name from user profile
    const profile = userDetails?.profiles?.[0];
    const companyLogo = profile?.logo_url || '';
    const orgName = profile?.organization_name || '';

    // Synchronize branding with Laravel so the share link stays short
    try {
      await axios.post(`${LARAVEL_BACKEND_API_URL}v1/sync-branding`, {
        logo_url: companyLogo,
        org_name: orgName
      });
    } catch (err) {
      console.error('Failed to sync branding:', err);
    }

    // Short URL (logo & org handled by backend sync)
    const shareUrl = `${baseUrl}/view-media/${type}/${secureId}?show_details=0`;

    setShareData({
      rawId: rawMediaId,
      type: type,
      url: shareUrl,
      id: secureId,
      title: type === 'photo' ? 'Share Photo' : type === 'document' ? 'Share Document' : 'Share Video',
      mediaUrl: mediaUrl,
      companyLogo: companyLogo,
      orgName: orgName
    });
    setShareModalVisible(true);
  };

  const copyToClipboard = () => {
    navigator.clipboard.writeText(shareData.url);
    setIsCopied(true);
    message.success('Link copied to clipboard!');
    setTimeout(() => setIsCopied(false), 2000);
  };
  const getDaySuffix = (day) => {
    if (day > 3 && day < 21) return "th";
    switch (day % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  };
  const fetchProject = () => {
    dispatch(getProject(project_id))
      .then((response) => {
        setProject(response);

        // Find the maximum order_index from existing images
        let maxIndex = 0;
        if (
          response?.inspection_images &&
          response.inspection_images.length > 0
        ) {
          maxIndex = response.inspection_images.reduce((max, img) => {
            return Math.max(max, img.order_index || 0);
          }, 0);
        }
        setMaxOrderIndex(maxIndex);

        const docs = response?.documents || response?.project_documents || [];
        setProjectDocuments(Array.isArray(docs) ? docs : []);
        setDocumentsTotal(response?.documents_count ?? (Array.isArray(docs) ? docs.length : 0));

        setDateImages(restructureData(response?.inspection_images));
      })
      .catch((error) => {
        message.error("Failed to fetch project");
      })
      .finally(() => {
        setLoading(false);
      });
  };
  useEffect(() => {
    fetchProject();
    loadProjectReports();
    fetchProjectVideos();
    // eslint-disable-next-line
  }, [project_id]);

  const loadProjectReports = async (page = 1, append = false) => {
    try {
      if (append) setLoadingMoreReports(true);

      const response = await dispatch(getProjectReports(project_id, page));
      const reports = Array.isArray(response) ? response : (response.data || []);

      setReportsTotal(response.total || reports.length);

      // Map backend field to frontend field
      const reportsWithImageCount = reports.map(report => ({
        ...report,
        total_images: report.total_image_count || report.total_images || 0
      }));

      setProjectReports(prev => append ? [...prev, ...reportsWithImageCount] : reportsWithImageCount);
    } catch (error) {
      console.error('Failed to load reports:', error);
      if (!append) setProjectReports([]);
    } finally {
      setLoadingMoreReports(false);
    }
  };
  const handleDeleteVideo = (videoId) => {
    Swal.fire({
      title: "Move to Recycle Bin?",
      text: "This video will be moved to the Recycle Bin and kept for 30 days before permanent deletion.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#0a497b",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Move to Recycle Bin",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const token = localStorage.getItem('fd_backend_token') || localStorage.getItem('jwt_token');
          await axios.delete(`${MEDIA_UPLOAD_URL_VIDEO}/${videoId}`, {
            headers: {
              Authorization: `Bearer ${token}`
            }
          });
          message.success("Video moved to recycle bin");
          setProjectVideos(prev => prev.filter(v => v.id !== videoId));
          setVideosTotal(prev => Math.max(0, prev - 1));
          loadTrashCount();
        } catch (error) {
          console.error("Failed to delete video:", error);
          message.error("Failed to move video to recycle bin");
        }
      }
    });
  };

  const fetchProjectVideos = async (page = 1, append = false) => {
    try {
      if (append) setLoadingVideos(true);
      else setLoadingVideos(true);

      const response = await axios.get(
        `${MEDIA_UPLOAD_URL_VIDEO}/project/${project_id}?per_page=10&page=${page}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('jwt_token')}`
          }
        }
      );

      const vids = response.data.data;
      setVideosTotal(response.data.total);

      if (append) {
        setProjectVideos(prev => [...prev, ...vids]);
      } else {
        setProjectVideos(vids);
      }
    } catch (error) {
      console.error('Failed to load videos:', error);
      message.error("Failed to fetch project videos");
      if (!append) setProjectVideos([]);
    } finally {
      setLoadingVideos(false);
    }
  };

  useEffect(() => {
    if (project?.inspection_images) {
      setDateImages(restructureData(project.inspection_images));
      // Build flat list sorted by order_index for Custom Order mode
      const sorted = [...project.inspection_images].sort((a, b) => {
        const aIdx = a.order_index || 0;
        const bIdx = b.order_index || 0;
        if (aIdx === 0 && bIdx === 0) return a.id - b.id;
        if (aIdx === 0) return 1;
        if (bIdx === 0) return -1;
        return sortOrder === 'desc' ? bIdx - aIdx : aIdx - bIdx;
      });
      setFlatImagesList(sorted.map(item => ({
        ...item,
        id: item?.id,
        image: item.image_url,
        description: item?.description,
        order_index: item?.order_index || 0,
        created_at: item.created_at,
      })));
    } // eslint-disable-next-line
  }, [sortOrder, project]);

  const loadTrashCount = useCallback(() => {
    if (project_id) {
      dispatch(getProjectTrashImages(project_id))
        .then((res) => {
          if (Array.isArray(res)) setTrashCount(res.length);
        })
        .catch(() => {});
    }
  }, [dispatch, project_id]);

  useEffect(() => {
    loadTrashCount();
  }, [loadTrashCount]);

  if (loading) {
    return (
      <div className="p-6">
        <div className="container-xxl">
          <div className="Skeleton_cover project-detail-skeleton">
            <Row
              gutter={16}
              className="d-flex align-items-center justify-content-between"
              style={{
                borderBottom: "1px solid #f0f0f0",
                paddingBottom: "10px",
                marginBottom: "20px",
              }}
            >
              <Col
                xs={12}
                md={12}
                xl={12}
                className="sklpad  d-flex align-items-center justify-content-start"
              >
                <Skeleton.Input
                  className="mb-1"
                  active
                  size="default"
                  style={{
                    height: "38px",
                    width: "200px",
                    borderRadius: "8px",
                  }}
                />
              </Col>
              <Col
                xs={12}
                md={12}
                xl={12}
                className="sklpad d-flex align-items-center justify-content-end"
              >
                <Skeleton.Avatar active size="default" shape={avatarShape} />
              </Col>
            </Row>
            <Row
              gutter={16}
              className="d-flex align-items-center justify-content-md-start"
              style={{
                borderBottom: "1px solid #f0f0f0",
                paddingBottom: "20px",
                marginBottom: "20px",
              }}
            >
              <Col
                xs={24}
                md={8}
                xl={6}
                className="sklpad d-flex align-items-center justify-content-start"
              >
                <Skeleton.Image
                  className="pro-detail-skeleton-large-img"
                  active
                  size="large"
                  style={{ borderRadius: "8px", marginBottom: "20px" }}
                />
              </Col>
              <Col xs={24} md={16} xl={18} className="sklpad">
                <Skeleton.Input
                  className="mb-1"
                  block={true}
                  active
                  size="default"
                  style={{ height: "22px" }}
                />
                <Skeleton.Input
                  className="mb-1"
                  block={true}
                  active
                  size="large"
                  style={{ height: "26px" }}
                />
                <Skeleton.Input
                  className="mb-1"
                  block={true}
                  active
                  size="default"
                  style={{ height: "18px" }}
                />
              </Col>
            </Row>
            <Row
              gutter={16}
              className="d-flex align-items-center justify-content-between"
              style={{ marginBottom: "30px" }}
            >
              <Col
                xs={12}
                md={12}
                xl={12}
                className="sklpad  d-flex align-items-center justify-content-start"
              ></Col>
              <Col
                xs={12}
                md={12}
                xl={12}
                className="sklpad d-flex align-items-center justify-content-end"
              >
                <Skeleton.Input
                  className="mb-1 mx-1"
                  active
                  size="default"
                  style={{
                    height: "42px",
                    width: "150px",
                    borderRadius: "8px",
                  }}
                />
              </Col>
            </Row>
            <Row
              gutter={16}
              className="d-flex align-items-center justify-content-between"
              style={{ marginBottom: "30px" }}
            >
              <Col
                xs={24}
                md={24}
                xl={24}
                className="sklpad d-flex align-items-center"
              >
                <Skeleton.Input
                  className="mb-1 mx-1"
                  block={true}
                  active
                  size="default"
                  style={{ height: "142px", borderRadius: "8px" }}
                />
              </Col>
            </Row>
            <div className="mb-5">
              {Array.from({ length: 2 }).map((_, i) => (
                <div key={i}>
                  <Row className="mt-3 project-detail-images-skeleton">
                    <Col
                      xs={12}
                      sm={8}
                      md={6}
                      xl={4}
                      className="sklpad mb-2 px-2"
                    >
                      <Skeleton.Image
                        active
                        size="large"
                        style={{ borderRadius: "8px" }}
                      />
                    </Col>
                    <Col
                      xs={12}
                      sm={8}
                      md={6}
                      xl={4}
                      className="sklpad mb-2 px-2"
                    >
                      <Skeleton.Image
                        active
                        size="large"
                        style={{ borderRadius: "8px" }}
                      />
                    </Col>
                    <Col
                      xs={12}
                      sm={8}
                      md={6}
                      xl={4}
                      className="sklpad mb-2 px-2"
                    >
                      <Skeleton.Image
                        active
                        size="large"
                        style={{ borderRadius: "8px" }}
                      />
                    </Col>
                    <Col
                      xs={12}
                      sm={8}
                      md={6}
                      xl={4}
                      className="sklpad mb-2 px-2"
                    >
                      <Skeleton.Image
                        active
                        size="large"
                        style={{ borderRadius: "8px" }}
                      />
                    </Col>
                    <Col
                      xs={12}
                      sm={8}
                      md={6}
                      xl={4}
                      className="sklpad mb-2 px-2"
                    >
                      <Skeleton.Image
                        active
                        size="large"
                        style={{ borderRadius: "8px" }}
                      />
                    </Col>
                    <Col
                      xs={12}
                      sm={8}
                      md={6}
                      xl={4}
                      className="sklpad mb-2 px-2"
                    >
                      <Skeleton.Image
                        active
                        size="large"
                        style={{ borderRadius: "8px" }}
                      />
                    </Col>
                  </Row>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  }

  const handleReorderImages = async () => {
    setIsSavingOrder(true);
    const allImages = [...flatImagesList];

    const updates = [];
    allImages.forEach((img, index) => {
      const newOrderIndex = index + 1;
      if (img.order_index !== newOrderIndex) {
        updates.push({ id: img.id, order_index: newOrderIndex });
      }
    });

    if (updates.length === 0) {
      message.info('No changes to save');
      setIsSavingOrder(false);
      return;
    }

    try {
      await dispatch(batchReorderImages(project_id, updates));
      message.success(`${updates.length} image(s) reordered!`);
      setReorderMode(false);
      setSelectedForReorder([]);
      setHasReorderChanges(false);
      setSwitchedFromDateMode(false);
      fetchProject();
    } catch (error) {
      message.error('Failed to reorder images');
      console.error(error);
    } finally {
      setIsSavingOrder(false);
    }
  };

  const handleDragStartDnd = (event) => {
    setSwitchedFromDateMode(false);
    const { active } = event;
    const activeId = active.id;
    let draggedImg = null;

    if (galleryViewMode === 'index') {
      draggedImg = flatImagesList.find(img => img.id === activeId);
    } else {
      for (const d in dateImages) {
        const found = dateImages[d]?.find(img => img.id === activeId);
        if (found) {
          draggedImg = found;
          break;
        }
      }
    }

    const isMulti = selectedForReorder.includes(activeId) && selectedForReorder.length > 1;

    let stackImages = [];
    if (isMulti) {
      let allSelected = [];
      if (galleryViewMode === 'index') {
        allSelected = flatImagesList.filter(img => selectedForReorder.includes(img.id));
      } else {
        for (const d in dateImages) {
          const matching = dateImages[d]?.filter(img => selectedForReorder.includes(img.id));
          if (matching?.length) allSelected.push(...matching);
        }
      }
      const activeObj = allSelected.find(img => img.id === activeId) || draggedImg;
      const otherObjs = allSelected.filter(img => img.id !== activeId);
      stackImages = [activeObj, ...otherObjs].filter(Boolean).slice(0, 4);
    }

    setActiveDragItem({
      id: activeId,
      image: draggedImg,
      count: isMulti ? selectedForReorder.length : 1,
      isMultiple: isMulti,
      stackImages: isMulti ? stackImages : [draggedImg],
    });
  };

  const handleDragEndDnd = (event) => {
    const { active, over } = event;
    setActiveDragItem(null);

    if (!over || active.id === over.id) {
      return;
    }

    if (galleryViewMode === 'index') {
      const isMultiple = selectedForReorder.includes(active.id) && selectedForReorder.length > 1;

      if (isMultiple) {
        const draggedIds = selectedForReorder;
        const selectedItems = flatImagesList.filter(img => draggedIds.includes(img.id));
        const remaining = flatImagesList.filter(img => !draggedIds.includes(img.id));
        const targetIdx = remaining.findIndex(img => img.id === over.id);
        const insertIdx = targetIdx >= 0 ? targetIdx : remaining.length;
        remaining.splice(insertIdx, 0, ...selectedItems);
        setFlatImagesList(remaining);
        setHasReorderChanges(true);
        message.info(`${selectedItems.length} image(s) moved`);
      } else {
        const oldIndex = flatImagesList.findIndex(img => img.id === active.id);
        const newIndex = flatImagesList.findIndex(img => img.id === over.id);
        if (oldIndex !== -1 && newIndex !== -1) {
          const newFlatList = arrayMove(flatImagesList, oldIndex, newIndex);
          setFlatImagesList(newFlatList);
          setHasReorderChanges(true);
          message.info('1 image moved');
        }
      }
    } else {
      // Date mode
      let sourceDate = null;
      let targetDate = null;

      for (const d in dateImages) {
        if (dateImages[d]?.some(img => img.id === active.id)) {
          sourceDate = d;
        }
        if (dateImages[d]?.some(img => img.id === over.id)) {
          targetDate = d;
        }
      }

      if (!sourceDate || !targetDate) return;

      if (sourceDate !== targetDate) {
        message.info('To rearrange photos across different dates, switch to "Custom Order" mode.');
        return;
      }

      const list = [...(dateImages[sourceDate] || [])];
      const isMultiple = selectedForReorder.includes(active.id) && selectedForReorder.length > 1;

      if (isMultiple) {
        const draggedIds = selectedForReorder;
        const selectedItems = list.filter(img => draggedIds.includes(img.id));
        const remaining = list.filter(img => !draggedIds.includes(img.id));
        const targetIdx = remaining.findIndex(img => img.id === over.id);
        const insertIdx = targetIdx >= 0 ? targetIdx : remaining.length;
        remaining.splice(insertIdx, 0, ...selectedItems);
        setDateImages(prev => ({ ...prev, [sourceDate]: remaining }));
        setHasReorderChanges(true);
        message.info(`${selectedItems.length} image(s) moved`);
      } else {
        const oldIndex = list.findIndex(img => img.id === active.id);
        const newIndex = list.findIndex(img => img.id === over.id);
        if (oldIndex !== -1 && newIndex !== -1) {
          const newList = arrayMove(list, oldIndex, newIndex);
          setDateImages(prev => ({ ...prev, [sourceDate]: newList }));
          setHasReorderChanges(true);
          message.info('1 image moved');
        }
      }
    }
  };

  const handleSelectAll = () => {
    const allImageIds = [];
    Object.values(dateImages).forEach(images => {
      images.forEach(img => allImageIds.push(img.id));
    });
    setSelectedImages(allImageIds);
  };

  const handleDeselectAll = () => {
    setSelectedImages([]);
  };

  const handleChangedescription = (value, org_value, image_id) => {
    if (value === org_value) {
      return false;
    } else {
      let formData = {
        project_id,
        description: value,
      };

      setDateImages((prevDateImages) => {
        const updatedImages = { ...prevDateImages };
        for (const date in updatedImages) {
          const imageToUpdate = updatedImages[date].find(
            (image) => image.id === image_id
          );
          if (imageToUpdate) {
            imageToUpdate.description = value;
            break;
          }
        }
        return updatedImages;
      });
      setFlatImagesList((prev) =>
        prev.map((img) =>
          img.id === image_id ? { ...img, description: value } : img
        )
      );

      dispatch(updateProjectImage(project_id, image_id, formData))
        .then((res) => {
          message.success("Description updated successfully!");
        })
        .catch((error) => {
          if (
            error.response &&
            error.response.data &&
            error.response.data.errors &&
            error.response.data.errors.description
          ) {
            message.error(error.response.data.errors.description[0]);
          } else if (
            error.response &&
            error.response.data &&
            error.response.data.message
          ) {
            message.error(error.response.data.message);
          } else {
            message.error("An unknown error occurred.");
          }
          console.error({ error });
          // Revert optimistic update
          setDateImages((prevDateImages) => {
            const updatedImages = { ...prevDateImages };
            for (const date in updatedImages) {
              const imageToUpdate = updatedImages[date].find(
                (image) => image.id === image_id
              );
              if (imageToUpdate) {
                imageToUpdate.description = org_value; // revert to original value
                break;
              }
            }
            return updatedImages;
          });
          setFlatImagesList((prev) =>
            prev.map((img) =>
              img.id === image_id ? { ...img, description: org_value } : img
            )
          );
        });
    }
  };

  const handleChangeVideoDescription = async (value, org_value, video_id) => {
    if (value === org_value) return;

    // Optimistic update
    setProjectVideos((prevVideos) =>
      prevVideos.map((video) =>
        video.id === video_id ? { ...video, description: value } : video
      )
    );

    try {
      await axios.patch(`${MEDIA_UPLOAD_URL_VIDEO}/${video_id}`, { description: value }, {
        headers: { Authorization: `Bearer ${localStorage.getItem('jwt_token')}` }
      });
      message.success("Video description updated!");
    } catch (error) {
      console.error("Failed to update video description", error);
      message.error("Failed to update video description");
      // Revert optimistic update
      setProjectVideos((prevVideos) =>
        prevVideos.map((video) =>
          video.id === video_id ? { ...video, description: org_value } : video
        )
      );
    }
  };

  const handleEditImage = (image) => {
    const rawImageSrc = image.image || image.image_url;
    const cleanOriginalSrc = image.original_image_url || image.original_image_path || rawImageSrc;
    const annotations = image.annotations_data || null;

    const hasActiveAnnotations = annotations && (
      (Array.isArray(annotations) && annotations.length > 0) ||
      (Array.isArray(annotations.objects) && annotations.objects.length > 0)
    );

    // If active annotations exist, use the clean original photo as the background so old baked pixels are not duplicated.
    // If no active annotations, rawImageSrc is already the correctly oriented/rotated image.
    const baseSource = (hasActiveAnnotations && cleanOriginalSrc) ? cleanOriginalSrc : rawImageSrc;

    const imageObj = new window.Image();
    imageObj.crossOrigin = "Anonymous";
    imageObj.src = baseSource + (baseSource.includes("?") ? "&" : "?") + "not-from-cache-please";
    setSelectedImage(imageObj.src);
    setSelectedOriginalUrl(cleanOriginalSrc);
    setSelectedAnnotations(annotations);
    setImageId(image.id);
    setEditorVisible(true);
  };

  const handleModalClose = () => {
    setSelectedImage(null);
    setSelectedOriginalUrl(null);
    setSelectedAnnotations(null);
    setImageId(null);
    setEditorVisible(false);
  };

  const handleCopyImage = async (image) => {
    if (!image?.id || !project_id) return;
    try {
      setCopyingImageId(image.id);
      const newImage = await dispatch(duplicateProjectImage(project_id, image.id));

      // Instant local state update (CompanyCam feel - 0ms reload delay!)
      if (newImage && project) {
        const formattedNewImage = {
          ...newImage,
          image: newImage.image_url || image.image,
          annotations_data: null,
        };

        const currentImages = project.inspection_images ? [...project.inspection_images] : [];

        // Shift order_index in existing local images if needed
        const shiftedImages = currentImages.map((img) => {
          if (newImage.order_index && img.order_index >= newImage.order_index) {
            return { ...img, order_index: img.order_index + 1 };
          }
          return img;
        });

        // Insert the new image
        shiftedImages.push(formattedNewImage);

        // 1. Update project state
        setProject((prevProject) => ({
          ...prevProject,
          inspection_images: shiftedImages,
        }));

        // 2. Direct synchronous update of dateImages (eliminates useEffect delay)
        setDateImages(restructureData(shiftedImages));

        // 3. Direct synchronous update of flatImagesList (for Custom Order mode)
        const sorted = [...shiftedImages].sort((a, b) => {
          const aIdx = a.order_index || 0;
          const bIdx = b.order_index || 0;
          if (aIdx === 0 && bIdx === 0) return a.id - b.id;
          if (aIdx === 0) return 1;
          if (bIdx === 0) return -1;
          return sortOrder === 'desc' ? bIdx - aIdx : aIdx - bIdx;
        });
        setFlatImagesList(sorted.map((item) => ({
          id: item?.id,
          image: item.image || item.image_url,
          description: item?.description,
          order_index: item?.order_index || 0,
          created_at: item.created_at,
        })));
      }

      message.success("Photo copied successfully with description!");
      // Silent background sync without blocking UI
      fetchProject();
    } catch (error) {
      console.error("Failed to copy image:", error);
      const errMsg = error?.response?.data?.message || "Failed to copy photo. Please try again.";
      message.error(errMsg);
    } finally {
      setCopyingImageId(null);
    }
  };

  if (!project) return null;
  const handleDelete = (projectId) => {
    dispatch(deleteProject(projectId))
      .then(() => {
        message.success("Project deleted successfully");
        navigate("/projects");
      })
      .catch((error) => {
        message.error("Failed to delete project");
      });
  };

  const confirmDelete = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to delete this project?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        handleDelete(project?.id);
      }
    });
  };

  const handleRefresh = () => {
    setIsRefreshing(true);
    fetchProject();
    loadProjectReports();
    fetchProjectVideos();
    loadTrashCount();
    setTimeout(() => {
      setIsRefreshing(false);
      message.success("Project refreshed");
    }, 400);
  };

  const handleArchiveProject = () => {
    Swal.fire({
      title: 'Archive Project?',
      text: `Are you sure you want to archive "${project?.name}"? It will be moved to Archived Projects.`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#f59e0b',
      cancelButtonColor: '#64748b',
      confirmButtonText: 'Yes, Archive it!',
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await dispatch(archiveProject(project?.id));
          message.success('Project archived successfully');
          fetchProject();
        } catch (e) {
          message.error('Failed to archive project');
        }
      }
    });
  };

  const handleUnarchiveProject = () => {
    Swal.fire({
      title: 'Restore Project?',
      text: `Do you want to restore "${project?.name}" back to Active projects?`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#0284c7',
      cancelButtonColor: '#64748b',
      confirmButtonText: 'Yes, Restore to Active!',
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await dispatch(unarchiveProject(project?.id));
          message.success('Project restored to active');
          fetchProject();
        } catch (e) {
          message.error('Failed to restore project');
        }
      }
    });
  };

  const handleMenuClick = (e) => {
    if (e.key === "edit") {
      navigate(`/project-edit/?project_id=${project?.id}`);
    } else if (e.key === "delete") {
      confirmDelete();
    } else if (e.key === "history") {
      setHistoryDrawerVisible(true);
    } else if (e.key === "trash") {
      setTrashModalVisible(true);
    } else if (e.key === "archive") {
      handleArchiveProject();
    } else if (e.key === "unarchive") {
      handleUnarchiveProject();
    }
  };

  const deleteImagesInSequence = (selectedImages, projectId) => {
    if (!selectedImages || !projectId) return Promise.resolve();

    return selectedImages.reduce((promise, image) => {
      return promise.then(() => {
        return dispatch(deleteProjectImage(projectId, image));
      });
    }, Promise.resolve());
  };

  const downloadImagesAsZip = async () => {
    console.info("modified image download");
    const zip = new JSZip();
    const projectName = project?.name || "project";
    const sanitizedProjectName = projectName.replace(/\s+/g, "_").toLowerCase();
    const folderName = `${sanitizedProjectName}_modified_images`;
    const folder = zip.folder(folderName);

    // Get selected images in the order they appear on the screen
    const orderedSelectedImages = [];
    if (galleryViewMode === 'index') {
      flatImagesList.forEach((img) => {
        if (selectedImages.includes(img.id)) orderedSelectedImages.push(img);
      });
    } else {
      Object.keys(sortedObject).forEach((date) => {
        sortedObject[date].forEach((img) => {
          if (selectedImages.includes(img.id)) orderedSelectedImages.push(img);
        });
      });
    }

    if (orderedSelectedImages.length === 0) {
      message.warning("Please select images to download");
      return;
    }

    // Download all images in PARALLEL (fast) but store in ordered array
    const results = new Array(orderedSelectedImages.length).fill(null);

    await Promise.all(
      orderedSelectedImages.map((image, index) =>
        dispatch(getProjectImage(project?.id, image.id))
          .then((res) => {
            if (!res?.image_url) throw new Error("Image URL not found");
            return fetch(`${res.image_url}?cacheBust=${Date.now()}`);
          })
          .then((response) => {
            if (!response.ok) throw new Error("Failed to fetch image");
            return response.blob();
          })
          .then((blob) => {
            // Store blob at its correct index position
            results[index] = { blob, imageId: image.id };
          })
          .catch((error) => {
            console.error("Error processing image:", image.id, error);
          })
      )
    );

    // Add to ZIP in correct order (sequentially)
    results.forEach((result, index) => {
      if (result) {
        const paddedIndex = String(index + 1).padStart(3, "0");
        folder.file(`${paddedIndex}_image_${result.imageId}.jpg`, result.blob);
      }
    });

    try {
      const content = await zip.generateAsync({ type: "blob" });
      saveAs(content, `${sanitizedProjectName}_modified_images.zip`);
      Swal.fire("Success", "Images downloaded successfully.", "success");
    } catch (error) {
      console.error("Error generating ZIP file:", error);
      Swal.fire("Error", "Failed to download images.", "error");
    }
  };

  const downloadOriginalImagesAsZip = async () => {
    console.info("original image download");
    const zip = new JSZip();
    const projectName = project?.name || "project";
    const sanitizedProjectName = projectName.replace(/\s+/g, "_").toLowerCase();
    const folderName = `${sanitizedProjectName}_original_images`;
    const folder = zip.folder(folderName);

    // Get selected images in the order they appear on the screen
    const orderedSelectedImages = [];
    if (galleryViewMode === 'index') {
      flatImagesList.forEach((img) => {
        if (selectedImages.includes(img.id)) orderedSelectedImages.push(img);
      });
    } else {
      Object.keys(sortedObject).forEach((date) => {
        sortedObject[date].forEach((img) => {
          if (selectedImages.includes(img.id)) orderedSelectedImages.push(img);
        });
      });
    }

    if (orderedSelectedImages.length === 0) {
      message.warning("Please select images to download");
      return;
    }

    // Download all images in PARALLEL (fast) but store in ordered array
    const results = new Array(orderedSelectedImages.length).fill(null);

    await Promise.all(
      orderedSelectedImages.map((image, index) =>
        dispatch(getProjectImage(project?.id, image.id))
          .then((res) => {
            if (!res?.original_image_url) throw new Error("Image URL not found");
            return fetch(`${res.original_image_url}?cacheBust=${Date.now()}`);
          })
          .then((response) => {
            if (!response.ok) throw new Error("Failed to fetch image");
            return response.blob();
          })
          .then((blob) => {
            // Store blob at its correct index position
            results[index] = { blob, imageId: image.id };
          })
          .catch((error) => {
            console.error("Error processing image:", image.id, error);
          })
      )
    );

    // Add to ZIP in correct order (sequentially)
    results.forEach((result, index) => {
      if (result) {
        const paddedIndex = String(index + 1).padStart(3, "0");
        folder.file(`${paddedIndex}_original_${result.imageId}.jpg`, result.blob);
      }
    });

    try {
      const content = await zip.generateAsync({ type: "blob" });
      saveAs(content, `${sanitizedProjectName}_original_images.zip`);
      Swal.fire("Success", "Images downloaded successfully.", "success");
    } catch (error) {
      console.error("Error generating ZIP file:", error);
      Swal.fire("Error", "Failed to download images.", "error");
    }
  };

  const handleMenuImagesClick = (e) => {
    if (selectedImages?.length > 0) {
      if (e?.key === "delete-images") {
        const count = selectedImages.length;
        Swal.fire({
          title: count === 1 ? "Move 1 Photo to Recycle Bin?" : `Move ${count} Photos to Recycle Bin?`,
          text: "Photos will be moved to the Recycle Bin. You can restore them back to the project at any time within 30 days.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#0a497b",
          cancelButtonColor: "#6c757d",
          confirmButtonText: "Yes, Move to Recycle Bin",
          cancelButtonText: "Cancel",
        }).then((result) => {
          if (result.isConfirmed) {
            Swal.fire({
              title: "Moving to Recycle Bin...",
              text: "Please wait while the photo(s) are moved to the Recycle Bin.",
              allowOutsideClick: false,
              didOpen: () => {
                Swal.showLoading();
              },
            });
            setDisabledImages([...selectedImages]);
            deleteImagesInSequence(selectedImages, project?.id)
              .then(() => {
                Swal.fire(
                  "Moved to Recycle Bin!",
                  `${count} photo(s) moved to the Recycle Bin. You can restore them within 30 days.`,
                  "success"
                );
                setSelectedImages([]);
                fetchProject();
                loadTrashCount();
              })
              .catch((error) => {
                console.error("Error moving images to recycle bin:", error);
                Swal.fire(
                  "Error!",
                  "Failed to move photos to recycle bin. Please try again.",
                  "error"
                );
                fetchProject();
              })
              .finally(() => {
                setDisabledImages([]);
              });
          }
        });
      } else if (e?.key === "download-original-images") {
        Swal.fire({
          title: "Downloading...",
          text: "Please wait while original images are being downloaded.",
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });
        downloadOriginalImagesAsZip();
      } else {
        Swal.fire({
          title: "Downloading...",
          text: "Please wait while modified images are being downloaded.",
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });
        downloadImagesAsZip();
      }
    }
  };

  const isArchived = Boolean(project?.is_archived || project?.archived_at);

  const menu = (
    <Menu
      mode="vertical"
      className="menu-single-project"
      onClick={handleMenuClick}
    >
      <Menu.Item key="edit" icon={<EditOutlined />}>
        Edit Project
      </Menu.Item>
      <Menu.Item key="history" icon={<HistoryOutlined />}>
        Project History
      </Menu.Item>
      <Menu.Item key="trash" icon={<span style={{ marginRight: 6 }}>♻️</span>}>
        Recycle Bin {trashCount > 0 ? `(${trashCount})` : ''}
      </Menu.Item>
      {isArchived ? (
        <Menu.Item key="unarchive" icon={<UndoOutlined />}>
          Restore to Active
        </Menu.Item>
      ) : (
        <Menu.Item key="archive" icon={<InboxOutlined />}>
          Archive Project
        </Menu.Item>
      )}
      <Menu.Item key="delete" danger icon={<DeleteOutlined />}>
        Delete Project
      </Menu.Item>
    </Menu>
  );
  const menuImages = (
    <Menu
      mode="vertical"
      className="menu-single-project"
      onClick={handleMenuImagesClick}
    >
      <Menu.Item key="download-images" disabled={selectedImages?.length === 0}>
        <DownloadOutlined /> Download Modified Images
      </Menu.Item>
      <Menu.Item
        key="download-original-images"
        disabled={selectedImages?.length === 0}
      >
        <DownloadOutlined /> Download Original Images
      </Menu.Item>
      <Menu.Item key="delete-images" disabled={selectedImages?.length === 0} danger>
        <span style={{ marginRight: 6 }}>♻️</span> Move to Recycle Bin
      </Menu.Item>
    </Menu>
  );

  const handleCreateReport = () => {
    if (!reportTitle.trim()) {
      message.error('Please enter a report title');
      return;
    }

    if (selectedImages.length === 0) {
      message.error('Please select at least one image');
      return;
    }

    setCreatingReport(true);
    const reportData = {
      title: reportTitle,
      photos_per_page: photosPerPage,
      selected_images: selectedImages,
      claim_number: claimNumber
    };

    dispatch(createReport(project_id, reportData))
      .then((response) => {
        message.success('Report created successfully!');
        setReportModalVisible(false);
        setReportTitle('');
        setPhotosPerPage(2);
        setLayoutOptions([]);
        setClaimNumber('');
        loadProjectReports();

        // Add selected_images to response before navigation
        const reportWithImages = {
          ...response,
          selected_images: selectedImages,
          selectedImages: selectedImages
        };

        setSelectedImages([]);
        navigate(`/project-photo-report/${response.id}`, { state: { report: reportWithImages } });
      })
      .catch((error) => {
        message.error('Failed to create report');
        console.error(error);
      })
      .finally(() => {
        setCreatingReport(false);
      });
  };

  const menuReports = (
    <Menu>
      <Menu.Item key="create-report" className="create-newreport" onClick={() => setReportModalVisible(true)}>
        <PlusCircleOutlined /> Create New Report
      </Menu.Item>
    </Menu>
  );

  const renderImagesByIndex = () => {
    const handleCheckboxChange = (ids, isChecked) => {
      setSelectedImages((prevSelectedImages) => {
        const updatedSelectedImages = [...prevSelectedImages];
        ids.forEach((image) => {
          if (isChecked) {
            if (!updatedSelectedImages.includes(image.id)) {
              updatedSelectedImages.push(image.id);
            }
          } else {
            const index = updatedSelectedImages.indexOf(image.id);
            if (index !== -1) {
              updatedSelectedImages.splice(index, 1);
            }
          }
        });
        return updatedSelectedImages;
      });
    };

    const getShortDate = (dateStr) => {
      if (!dateStr) return '';
      const d = new Date(dateStr);
      return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
    };

    const onImagePreviewClick = (image) => {
      const clickedIndex = flatImagesList.findIndex(img => img.id === image.id);
      setFdcamMediaList([...flatImagesList]);
      setFdcamInitialIndex(clickedIndex >= 0 ? clickedIndex : 0);
      setFdcamMediaType('image');
      setFdcamPreviewVisible(true);
    };

    return (
      <Row gutter={[16, 16]} className="mt-4 project-detail-bottom-row">
        <div className="w-100 mt-3">
          <SortableContext items={flatImagesList?.map(img => img.id) || []} strategy={rectSortingStrategy}>
            <Row className="images-base-on-date-row" gutter={[16, 16]}>
              {flatImagesList?.map((image, index) => (
                <SortableProjectImageCard
                  key={image.id}
                  image={image}
                  index={index}
                  reorderMode={reorderMode}
                  selectedForReorder={selectedForReorder}
                  onToggleReorderSelect={handleToggleReorderSelect}
                  selectedImages={selectedImages}
                  handleCheckboxChange={handleCheckboxChange}
                  disabledImages={disabledImages}
                  handleCopyImage={handleCopyImage}
                  copyingImageId={copyingImageId}
                  handleEditImage={handleEditImage}
                  handleShareClick={handleShareClick}
                  editingDescriptionId={editingDescriptionId}
                  setEditingDescriptionId={setEditingDescriptionId}
                  descriptionValue={descriptionValue}
                  setDescriptionValue={setDescriptionValue}
                  handleChangedescription={handleChangedescription}
                  showDateBadge={true}
                  getShortDate={getShortDate}
                  onImagePreviewClick={onImagePreviewClick}
                />
              ))}
            </Row>
          </SortableContext>
        </div>
      </Row>
    );
  };

  const renderImagesByDate = (imagesByDate) => {
    const handleCheckboxChange = (ids, isChecked) => {
      setSelectedImages((prevSelectedImages) => {
        const updatedSelectedImages = [...prevSelectedImages];

        ids.forEach((image) => {
          if (isChecked) {
            if (!updatedSelectedImages.includes(image.id)) {
              updatedSelectedImages.push(image.id);
            }
          } else {
            const index = updatedSelectedImages.indexOf(image.id);
            if (index !== -1) {
              updatedSelectedImages.splice(index, 1);
            }
          }
        });

        return updatedSelectedImages;
      });
    };

    const isAllChecked = (images) =>
      images.every((image) => selectedImages.includes(image.id));

    const isIndeterminate = (images) =>
      images.some((image) => selectedImages.includes(image.id)) &&
      !isAllChecked(images);

    const onImagePreviewClick = (image) => {
      const allImagesFlat = [];
      Object.values(imagesByDate).forEach(arr => allImagesFlat.push(...arr));
      const clickedIndex = allImagesFlat.findIndex(img => img.id === image.id);
      setFdcamMediaList(allImagesFlat);
      setFdcamInitialIndex(clickedIndex >= 0 ? clickedIndex : 0);
      setFdcamMediaType('image');
      setFdcamPreviewVisible(true);
    };

    return (
      <Row gutter={[16, 16]} className="mt-4 project-detail-bottom-row">
        {Object.entries(imagesByDate)?.map(([date, images]) => (
          <div className="w-100 mt-3" key={images[0]?.id || date}>
            <Checkbox
              className="main-project-checkbox"
              onChange={(e) => handleCheckboxChange(images, e.target.checked)}
              checked={isAllChecked(images)}
              indeterminate={isIndeterminate(images)}
            >
              <div className="single-project-date-time">{date}</div>
            </Checkbox>

            <div>
              <SortableContext items={images?.map(img => img.id) || []} strategy={rectSortingStrategy}>
                <Row className="images-base-on-date-row" gutter={[16, 16]}>
                  {images?.map((image, index) => (
                    <SortableProjectImageCard
                      key={image.id}
                      image={image}
                      index={index}
                      date={date}
                      reorderMode={reorderMode}
                      selectedForReorder={selectedForReorder}
                      onToggleReorderSelect={handleToggleReorderSelect}
                      selectedImages={selectedImages}
                      handleCheckboxChange={handleCheckboxChange}
                      disabledImages={disabledImages}
                      handleCopyImage={handleCopyImage}
                      copyingImageId={copyingImageId}
                      handleEditImage={handleEditImage}
                      handleShareClick={handleShareClick}
                      editingDescriptionId={editingDescriptionId}
                      setEditingDescriptionId={setEditingDescriptionId}
                      descriptionValue={descriptionValue}
                      setDescriptionValue={setDescriptionValue}
                      handleChangedescription={handleChangedescription}
                      showDateBadge={false}
                      getShortDate={() => date}
                      onImagePreviewClick={onImagePreviewClick}
                    />
                  ))}
                </Row>
              </SortableContext>
            </div>
          </div>
        ))}
      </Row>
    );
  };

  const progress = {
    strokeWidth: 5,
    showInfo: true,
    format: (percent) => (percent ? `${Math.round(percent)}%` : "0%"),
  };

  const handlePreview = async (file) => {
    if (file.originFileObj) {
      setLoading(true);
      setLoading(false);
    }
  };

  const onChange = (info) => {
    if (info.file.status === "uploading") {
      // When a file starts uploading, assign it an order_index
      const newFileList = [...info.fileList];
      const fileIndex = newFileList.findIndex(
        (file) => file.uid === info.file.uid
      );

      if (fileIndex !== -1 && !newFileList[fileIndex].order_index) {
        newFileList[fileIndex].order_index = maxOrderIndex + fileIndex + 1;
      }

      setFileList(newFileList);
    }
    if (info.file.status === "removed") {
      setFileList(info.fileList);
    }
    if (info.file.status === "done") {
      let newFileList = [...fileList];
      let index = newFileList.findIndex((ele) => ele.uid === info.file.uid);
      newFileList[index]["status"] = "done";
      newFileList[index]["media_id"] = info.file.response.data.id;
      newFileList[index]["url"] = info.file.response.data.source_url;

      setFileList(newFileList);
      setUploadCount((prevCount) => prevCount + 1);
      const fileInfo = info?.fileList?.filter(
        (item) =>
          item?.type !== "" &&
          !item?.type?.includes("document") &&
          !item?.type?.includes("video")
      );
      if (uploadCount + 1 === fileInfo.length) {
        // Update the maxOrderIndex for the next batch
        setMaxOrderIndex(maxOrderIndex + fileInfo.length);
        setUploadCount(0);
        setFileList([]);
        message.success("All images uploaded successfully");
        fetchProject();
      }
    }
  };

  const beforeUpload = (file) => {
    const isImage = file.type.startsWith("image/");

    if (!isImage) {
      message.error(
        "You can only upload image files (heic, heif, document and videos not supported)!"
      );
    }
    return isImage;
  };
  const uploadImage = async (options) => {
    const { onSuccess, onError, file, onProgress } = options;
    const fmData = new FormData();
    const config = {
      headers: {
        "content-type": "multipart/form-data",
      },
      onUploadProgress: (event) => {
        onProgress({ percent: (event.loaded / event.total) * 100 });
      },
    };

    // Find the file in fileList to get its assigned order_index
    const fileItem = fileList.find((item) => item.uid === file.uid);
    // Use the order_index that was assigned in the onChange function
    const orderIndex = fileItem?.order_index || maxOrderIndex + 1;

    fmData.append("image", file);
    fmData.append("project_id", project_id);
    fmData.append("order_index", orderIndex);

    try {
      const res = await axios.post(
        `${LARAVEL_BACKEND_API_URL}projects/${project_id}/images`,
        fmData,
        config
      );
      onSuccess(res);
    } catch (err) {
      console.log("Error: ", err);
      const error = new Error("Some error");
      onError({ err });
      console.warn(error);
    }
  };

  const onVideoChange = (info) => {
    if (info.file.status === "uploading") {
      const newFileList = [...info.fileList];
      const fileIndex = newFileList.findIndex(
        (file) => file.uid === info.file.uid
      );

      if (fileIndex !== -1 && !newFileList[fileIndex].order_index) {
        newFileList[fileIndex].order_index = maxVideoOrderIndex + fileIndex + 1;
      }

      setVideoFileList(newFileList);
    }
    if (info.file.status === "removed") {
      setVideoFileList(info.fileList);
    }
    if (info.file.status === "done") {
      let newFileList = [...videoFileList];
      let index = newFileList.findIndex((ele) => ele.uid === info.file.uid);
      if (index !== -1) {
        newFileList[index]["status"] = "done";
        newFileList[index]["media_id"] = info.file.response?.id || info.file.response?.data?.id;
        newFileList[index]["url"] = info.file.response?.source_url || info.file.response?.data?.source_url;
      }

      setVideoFileList(newFileList);
      setUploadVideoCount((prevCount) => prevCount + 1);
      const fileInfo = info?.fileList?.filter((item) => item?.type !== "");
      if (uploadVideoCount + 1 === fileInfo.length) {
        setMaxVideoOrderIndex(maxVideoOrderIndex + fileInfo.length);
        setUploadVideoCount(0);
        setVideoFileList([]);
        message.success("All videos uploaded successfully");
        fetchProjectVideos();
      }
    }
  };

  const generateVideoThumbnail = (file) => {
    return new Promise((resolve) => {
      try {
        const video = document.createElement("video");
        video.preload = "metadata";
        video.muted = true;
        video.playsInline = true;
        const targetFile = file?.originFileObj || file;
        if (!targetFile) return resolve(null);
        const url = URL.createObjectURL(targetFile);
        video.src = url;

        video.onloadeddata = () => {
          video.currentTime = Math.min(0.5, (video.duration > 1 ? 0.5 : 0));
        };

        video.onseeked = () => {
          try {
            const canvas = document.createElement("canvas");
            canvas.width = 240;
            canvas.height = 240;
            const ctx = canvas.getContext("2d");
            const hRatio = canvas.width / (video.videoWidth || 1);
            const vRatio = canvas.height / (video.videoHeight || 1);
            const ratio = Math.max(hRatio, vRatio);
            const centerShiftX = (canvas.width - video.videoWidth * ratio) / 2;
            const centerShiftY = (canvas.height - video.videoHeight * ratio) / 2;
            ctx.drawImage(
              video,
              0,
              0,
              video.videoWidth,
              video.videoHeight,
              centerShiftX,
              centerShiftY,
              video.videoWidth * ratio,
              video.videoHeight * ratio
            );
            const thumbUrl = canvas.toDataURL("image/jpeg", 0.85);
            URL.revokeObjectURL(url);
            resolve(thumbUrl);
          } catch (e) {
            URL.revokeObjectURL(url);
            resolve(null);
          }
        };

        video.onerror = () => {
          URL.revokeObjectURL(url);
          resolve(null);
        };

        setTimeout(() => {
          URL.revokeObjectURL(url);
          resolve(null);
        }, 2500);
      } catch (e) {
        resolve(null);
      }
    });
  };

  const beforeVideoUpload = (file) => {
    const isVideo = file.type?.startsWith("video/") || file.name?.match(/\.(mp4|mov|avi|wmv|flv|mkv|webm)$/i);
    if (!isVideo) {
      message.error("You can only upload video files here!");
      return false;
    }

    // Generate real video thumbnail preview frame
    generateVideoThumbnail(file).then((thumb) => {
      if (thumb) {
        file.thumbUrl = thumb;
        setVideoFileList((prev) =>
          prev.map((item) => (item.uid === file.uid ? { ...item, thumbUrl: thumb } : item))
        );
      }
    });

    return true;
  };

  const uploadVideo = async (options) => {
    const { onSuccess, onError, file, onProgress } = options;
    const fmData = new FormData();
    const config = {
      headers: {
        "content-type": "multipart/form-data",
        Authorization: `Bearer ${localStorage.getItem('jwt_token')}`
      },
      onUploadProgress: (event) => {
        onProgress({ percent: (event.loaded / event.total) * 100 });
      },
    };

    fmData.append("file", file);
    fmData.append("context", "general");
    fmData.append("project_id", project_id);

    try {
      const res = await axios.post(
        MEDIA_UPLOAD_URL_VIDEO,
        fmData,
        config
      );
      onSuccess(res.data);
    } catch (err) {
      console.log("Error: ", err);
      onError({ err });
    }
  };

  const normFile = (e) => {
    if (Array.isArray(e)) {
      return e && e.fileList;
    }

    return e && e.fileList;
  };

  return (
    <DndProvider backend={HTML5Backend}>
      <div className="p-6">
        <div className="container-xxl">
          <div className="button-navigations mt-5">
            <ButtonBar />
          </div>
        </div>
        <div className="project-detail-section container-xxl mb-5">
          <div className="project-detail-project-header">
            <div className="back-button">
              <div className="row align-items-center">
                <div className="col-sm-6 col-12 mb-2 mb-sm-0">
                  <Button
                    className="button-back"
                    type="button"
                    onClick={() => navigate(`/projects/`)}
                  >
                    <ArrowLeftOutlined />
                    Back to Projects
                  </Button>
                </div>
                <div className="col-sm-6 col-12 text-end header-top-action-bar">
                  <button
                    type="button"
                    className={`detail-action-btn refresh-btn ${isRefreshing ? 'is-loading' : ''}`}
                    onClick={handleRefresh}
                    disabled={isRefreshing}
                    aria-label="Refresh Project"
                  >
                    <ReloadOutlined spin={isRefreshing} className="action-icon" />
                    <span className="action-label action-label-desktop">
                      {isRefreshing ? 'Refreshing...' : 'Refresh'}
                    </span>
                  </button>

                  <button
                    type="button"
                    className="detail-action-btn history-btn"
                    onClick={() => setHistoryDrawerVisible(true)}
                    aria-label="Project History"
                  >
                    <HistoryOutlined className="action-icon" />
                    <span className="action-label action-label-desktop">History</span>
                  </button>

                  <button
                    type="button"
                    className="detail-action-btn trash-btn"
                    onClick={() => setTrashModalVisible(true)}
                    aria-label="Recycle Bin"
                    title="View Deleted Media (Recoverable for 30 days)"
                  >
                    <span className="action-icon" style={{ fontSize: "14px", display: "inline-flex", alignItems: "center" }}>♻️</span>
                    <span className="action-label">
                      <span className="action-label-desktop">Recycle Bin</span>
                      <span className="action-label-mobile">Bin</span>
                      {trashCount > 0 && (
                        <span style={{
                          marginLeft: 6,
                          background: "#e11d48",
                          color: "#fff",
                          borderRadius: 10,
                          padding: "1px 6px",
                          fontSize: 11,
                          fontWeight: 700
                        }}>
                          {trashCount}
                        </span>
                      )}
                    </span>
                  </button>

                  <Dropdown
                    overlay={menu}
                    trigger={["click"]}
                    placement="bottomRight"
                    destroyPopupOnHide={true}
                    transitionName=""
                    getPopupContainer={() => document.body}
                  >
                    <Button
                      className="single-project-menu-btn"
                      icon={<EllipsisOutlined />}
                      style={{ height: 38, width: 38, borderRadius: 8, touchAction: "manipulation" }}
                    ></Button>
                  </Dropdown>
                </div>
              </div>
            </div>
            <div className="row align-items-center project-detail-top-row">
              <div className="col-lg-3 col-md-4">
                <div className="pro-detail-header-image">
                  {project?.inspection_images?.length > 0 ? (
                    <img
                      className="pro-folder-img"
                      alt="folder-image"
                      src={project?.inspection_images?.[0]?.image_url}
                    />
                  ) : (
                    <img
                      className="pro-folder-img-icon"
                      alt="folder-image"
                      src={placeholderIMage}
                    />
                  )}
                </div>
              </div>
              <div className="col-lg-9 col-md-8">
                <h3 className="single-detail-project-heading" style={{ display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap" }}>
                  <span>{project?.name}</span>
                  {(project?.is_archived || project?.archived_at) && (
                    <span
                      style={{
                        fontSize: 13,
                        fontWeight: 700,
                        color: "#b45309",
                        background: "#fef3c7",
                        border: "1px solid #fde68a",
                        padding: "3px 10px",
                        borderRadius: 6,
                        display: "inline-flex",
                        alignItems: "center",
                        gap: 5,
                        letterSpacing: "0.03em"
                      }}
                    >
                      <InboxOutlined /> ARCHIVED
                    </span>
                  )}
                </h3>
                <div className="project-address-description">
                  <p className="address">
                    {project?.address}, {project?.city}, {project?.state},{" "}
                    {project?.postal_code}
                  </p>
                  <p className="descriptions">
                    {project?.description || "No description provided"}
                  </p>
                  <p className="created-at">
                    Created At:-{" "}
                    {new Date(project?.created_at).toLocaleString()}
                  </p>
                  <p className="updated-at">
                    Updated At:-{" "}
                    {new Date(project?.updated_at).toLocaleString()}
                  </p>
                </div>
              </div>
            </div>

            <div className="row mt-4 mb-3">
              <div className="col-md-12 d-flex justify-content-center">
                <div className="sliding-pill-switch triple-switch">
                  <span
                    className={`sliding-pill-glider ${
                      uploadView === 'videos' ? 'pos-1' : uploadView === 'documents' ? 'pos-2' : 'pos-0'
                    }`}
                  />
                  <button
                    type="button"
                    className={`sliding-pill-btn ${uploadView === 'photos' ? 'active' : ''}`}
                    onClick={() => setUploadView('photos')}
                  >
                    <PictureOutlined className="pill-btn-icon" />
                    <span className="pill-btn-label-desktop">Upload Photos</span>
                    <span className="pill-btn-label-mobile">Photos</span>
                  </button>
                  <button
                    type="button"
                    className={`sliding-pill-btn ${uploadView === 'videos' ? 'active' : ''}`}
                    onClick={() => setUploadView('videos')}
                  >
                    <VideoCameraOutlined className="pill-btn-icon" />
                    <span className="pill-btn-label-desktop">Upload Videos</span>
                    <span className="pill-btn-label-mobile">Videos</span>
                  </button>
                  <button
                    type="button"
                    className="sliding-pill-btn"
                    onClick={() => setUploadDocModalVisible(true)}
                  >
                    <FilePdfOutlined className="pill-btn-icon" />
                    <span className="pill-btn-label-desktop">Upload Documents</span>
                    <span className="pill-btn-label-mobile">Documents</span>
                  </button>
                </div>
              </div>
            </div>

            <div id="project-upload-section">
              {uploadView === 'photos' && (
                <div className="row">
                  <div className="col-md-12 text-right">
                    <div
                      className="project-upload-img-btn text-right pt-0 mt-0"
                      style={{ border: "none" }}
                    >
                      <>
                        <DndProvider backend={HTML5Backend}>
                          <Form.Item
                            name="dragger"
                            valuePropName={fileList}
                            getValueFromEvent={normFile}
                            noStyle
                          >
                            <Upload
                              name="files"
                              multiple={true}
                              accept="image/*"
                              beforeUpload={beforeUpload}
                              customRequest={uploadImage}
                              listType="picture-card"
                              fileList={fileList}
                              onChange={onChange}
                              onPreview={handlePreview}
                              progress={progress}
                            >
                              <p className="file-image-drag-btn">
                                Drop or Upload Photos Here
                              </p>
                            </Upload>
                          </Form.Item>
                        </DndProvider>
                      </>
                    </div>
                  </div>
                </div>
              )}

              {uploadView === 'videos' && (
                <div className="row">
                  <div className="col-md-12 text-right">
                    <div
                      className="project-upload-img-btn text-right pt-0 mt-0"
                      style={{ border: "none" }}
                    >
                      <>
                        <DndProvider backend={HTML5Backend}>
                          <Form.Item
                            name="videoDragger"
                            valuePropName={videoFileList}
                            getValueFromEvent={normFile}
                            noStyle
                          >
                            <Upload
                              name="videos"
                              multiple={true}
                              accept="video/*"
                              beforeUpload={beforeVideoUpload}
                              customRequest={uploadVideo}
                              listType="picture-card"
                              fileList={videoFileList}
                              onChange={onVideoChange}
                              onPreview={handlePreview}
                              progress={progress}
                              itemRender={(originNode, file, fileList, actions) => {
                                const isUploading = file.status === "uploading";
                                const isError = file.status === "error";
                                const percent = Math.min(100, Math.max(0, Math.round(file.percent || 0)));
                                const thumbUrl = file.thumbUrl;

                                return (
                                  <div className={`custom-video-upload-card ${isError ? "is-error" : ""}`}>
                                    {thumbUrl ? (
                                      <img
                                        src={thumbUrl}
                                        alt="Video thumbnail"
                                        className="custom-video-thumb-bg"
                                      />
                                    ) : null}
                                    <div className={`custom-video-card-body ${thumbUrl ? "has-thumb" : ""}`}>
                                      <div
                                        className={`custom-video-play-icon ${
                                          isUploading ? "uploading" : ""
                                        } ${isError ? "error" : ""}`}
                                      >
                                        <PlayCircleFilled />
                                      </div>
                                      {isUploading && (
                                        <div className="custom-video-progress-container">
                                          <span className="custom-video-progress-val">
                                            {percent}%
                                          </span>
                                          <div className="custom-video-progress-track">
                                            <div
                                              className="custom-video-progress-bar"
                                              style={{ width: `${percent}%` }}
                                            />
                                          </div>
                                        </div>
                                      )}
                                      {!isUploading && !isError && (
                                        <span className="custom-video-done-badge">
                                          VIDEO
                                        </span>
                                      )}
                                      {isError && (
                                        <span className="custom-video-error-badge">
                                          Failed
                                        </span>
                                      )}
                                    </div>
                                    {actions?.remove && (
                                      <button
                                        type="button"
                                        className="custom-video-cancel-btn"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          actions.remove();
                                        }}
                                        title="Cancel"
                                      >
                                        ×
                                      </button>
                                    )}
                                  </div>
                                );
                              }}
                              iconRender={(file) => {
                                const isUploading = file.status === "uploading";
                                return (
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      width: "100%",
                                      height: "100%",
                                    }}
                                  >
                                    <div
                                      style={{
                                        width: 36,
                                        height: 36,
                                        borderRadius: "50%",
                                        background: "linear-gradient(135deg, #0038d1 0%, #1d4ed8 100%)",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        color: "#ffffff",
                                        fontSize: 18,
                                        boxShadow: "0 2px 6px rgba(0, 56, 209, 0.28)",
                                      }}
                                    >
                                      <PlayCircleFilled />
                                    </div>
                                    {!isUploading && (
                                      <span
                                        style={{
                                          fontSize: 9.5,
                                          fontWeight: 700,
                                          color: "#0038d1",
                                          marginTop: 4,
                                          letterSpacing: "0.5px",
                                        }}
                                      >
                                        VIDEO
                                      </span>
                                    )}
                                  </div>
                                );
                              }}
                            >
                              <p className="file-image-drag-btn">
                                Drop or Upload Videos Here
                              </p>
                            </Upload>
                          </Form.Item>
                        </DndProvider>
                      </>
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div className="row actions-header-project-detail" style={{
              position: 'sticky',
              top: 0,
              zIndex: 50,
              background: 'white',
              marginBottom: '16px',
              boxShadow: '0 2px 8px rgba(0,0,0,0.06)'
            }}>
              <div className="col-md-12">
                <div className="toolbar-flex-row">
                  {!reorderMode ? (
                    <>
                      <div className="sliding-pill-switch sm">
                        <span
                          className={`sliding-pill-glider ${galleryViewMode === 'date' ? 'slide-right' : ''}`}
                        />
                        <button
                          type="button"
                          className={`sliding-pill-btn ${galleryViewMode === 'index' ? 'active' : ''}`}
                          onClick={() => setGalleryViewMode('index')}
                        >
                          <OrderedListOutlined className="pill-btn-icon" />
                          <span className="toolbar-btn-label-desktop">Custom Order</span>
                          <span className="toolbar-btn-label-mobile">Order</span>
                        </button>
                        <button
                          type="button"
                          className={`sliding-pill-btn ${galleryViewMode === 'date' ? 'active' : ''}`}
                          onClick={() => setGalleryViewMode('date')}
                        >
                          <CalendarOutlined className="pill-btn-icon" />
                          <span className="toolbar-btn-label-desktop">Group by Date</span>
                          <span className="toolbar-btn-label-mobile">Date</span>
                        </button>
                      </div>

                      <Button
                        className="header-action-pill-btn d-flex align-items-center"
                        icon={sortOrder === "asc" ? <ArrowUpOutlined /> : <ArrowDownOutlined />}
                        onClick={() => setSortOrder(sortOrder === "asc" ? "desc" : "asc")}
                      >
                        <span className="toolbar-btn-label-desktop">
                          {galleryViewMode === 'index'
                            ? (sortOrder === "asc" ? "Order: 1 → N" : "Order: N → 1")
                            : (sortOrder === "asc" ? "Oldest First" : "Newest First")}
                        </span>
                        <span className="toolbar-btn-label-mobile">
                          {galleryViewMode === 'index'
                            ? (sortOrder === "asc" ? "1 → N" : "N → 1")
                            : (sortOrder === "asc" ? "Oldest" : "Newest")}
                        </span>
                      </Button>

                      <Button className="header-action-pill-btn" onClick={handleSelectAll}>
                        <span className="toolbar-btn-label-desktop">Select All ({totalImagesCount})</span>
                        <span className="toolbar-btn-label-mobile">All ({totalImagesCount})</span>
                      </Button>

                      {selectedImages.length > 0 && (
                        <Button
                          className="header-action-pill-btn"
                          onClick={handleDeselectAll}
                        >
                          Deselect All
                        </Button>
                      )}

                      {selectedImages.length > 0 && (
                        <span className="selected-indicator-pill">
                          ✓ {selectedImages.length} Selected
                        </span>
                      )}

                      <Button
                        className="header-action-pill-btn btn-reorder-highlight d-flex align-items-center"
                        icon={<DragOutlined />}
                        onClick={() => {
                          if (selectedImages && selectedImages.length > 0) {
                            setSelectedForReorder([...selectedImages]);
                          }
                          if (galleryViewMode === 'date') {
                            setGalleryViewMode('index');
                            setSwitchedFromDateMode(true);
                          } else {
                            setSwitchedFromDateMode(false);
                          }
                          setReorderMode(true);
                        }}
                      >
                        <span className="toolbar-btn-label-desktop">Reorder Images</span>
                        <span className="toolbar-btn-label-mobile">Reorder</span>
                      </Button>

                      <Button
                        className="header-action-pill-btn d-flex align-items-center"
                        icon={<FilePdfOutlined />}
                        type={showDocuments ? "primary" : "default"}
                        onClick={() => {
                          setShowDocuments(!showDocuments);
                        }}
                      >
                        <span className="toolbar-btn-label-desktop">{showDocuments ? 'Hide Document' : 'Show Document'} ({documentsTotal})</span>
                        <span className="toolbar-btn-label-mobile">{showDocuments ? 'Hide Document' : 'Show Document'} ({documentsTotal})</span>
                      </Button>

                      {reportsTotal > 0 && (
                        <Button
                          className="header-action-pill-btn d-flex align-items-center"
                          icon={<FileTextOutlined />}
                          type={showReports ? "primary" : "default"}
                          onClick={() => {
                            if (!showReports) loadProjectReports();
                            setShowReports(!showReports);
                          }}
                        >
                          <span className="toolbar-btn-label-desktop">{showReports ? 'Hide Reports' : 'Show Reports'} ({reportsTotal})</span>
                          <span className="toolbar-btn-label-mobile">{showReports ? 'Hide Reports' : 'Show Reports'} ({reportsTotal})</span>
                        </Button>
                      )}

                      {selectedImages.length > 0 && (
                        <Dropdown
                          overlay={menuReports}
                          trigger={["click"]}
                          placement="bottomRight"
                          destroyPopupOnHide={true}
                          transitionName=""
                          getPopupContainer={() => document.body}
                        >
                          <Button type="primary" className="header-action-pill-btn btn-primary-action" style={{ touchAction: "manipulation" }}>
                            <span style={{ display: "flex", alignItems: "center", gap: "5px", color: "#ffffff" }}>
                              Reports <CaretDownOutlined style={{ color: "#ffffff" }} />
                            </span>
                          </Button>
                        </Dropdown>
                      )}

                      <Dropdown
                        overlay={menuImages}
                        trigger={["click"]}
                        placement="bottomRight"
                        destroyPopupOnHide={true}
                        transitionName=""
                        getPopupContainer={() => document.body}
                      >
                        <Button className="header-action-pill-btn" style={{ touchAction: "manipulation" }}>
                          <span style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                            Actions <CaretDownOutlined />
                          </span>
                        </Button>
                      </Dropdown>
                    </>
                  ) : (
                    <div className="d-flex align-items-center gap-3 flex-wrap" style={{ flexShrink: 0 }}>
                      <span style={{ color: '#0a497b', fontWeight: 'bold', fontSize: '15px', display: 'flex', alignItems: 'center', gap: '6px' }}>
                        <DragOutlined /> Click & drag to rearrange
                      </span>
                      <span style={{
                        background: '#e6f7ff',
                        color: '#0050b3',
                        padding: '3px 10px',
                        borderRadius: '50px',
                        fontSize: '11.5px',
                        fontWeight: '600',
                        border: '1px solid #91d5ff'
                      }}>
                        Custom Order Mode
                      </span>
                      {selectedForReorder.length > 0 && (
                        <>
                          <span style={{
                            background: '#f6ffed',
                            color: '#389e0d',
                            padding: '3px 10px',
                            borderRadius: '50px',
                            fontSize: '11.5px',
                            fontWeight: 'bold',
                            border: '1px solid #b7eb8f'
                          }}>
                            {selectedForReorder.length} selected for batch move
                          </span>
                          <Button
                            size="small"
                            className="header-action-pill-btn btn-clear-selection"
                            onClick={() => {
                              setSelectedForReorder([]);
                              setSelectedImages([]);
                            }}
                          >
                            <LuRefreshCcw /> Clear
                          </Button>
                        </>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Project Documents Section */}
            {showDocuments && (
              <div className="row mt-3 mb-4">
                <div className="col-md-12">
                  <ProjectDocuments
                    projectId={project_id}
                    projectName={project?.name}
                    documents={projectDocuments}
                    onDocumentsUpdated={(updatedDocs) => {
                      setProjectDocuments(updatedDocs);
                      setDocumentsTotal(updatedDocs.length);
                      loadTrashCount();
                    }}
                    onOpenUploadModal={() => setUploadDocModalVisible(true)}
                    onShareDocument={(doc) => handleShareClick('document', doc)}
                  />
                </div>
              </div>
            )}

            {/* Project Reports Section */}
            {showReports && (
              <div className="row mt-3 mb-4">
                <div className="col-md-12">
                  {projectReports.length === 0 ? (
                    <div style={{
                      textAlign: 'center',
                      padding: '40px 20px',
                      background: '#fafafa',
                      borderRadius: '8px',
                      border: '1px dashed #d9d9d9'
                    }}>
                      <FileTextOutlined style={{ fontSize: '48px', color: '#d9d9d9', marginBottom: '16px' }} />
                      <p style={{ color: '#888', fontSize: '16px', margin: 0 }}>No reports created for this project yet.</p>
                    </div>
                  ) : (
                    <>
                      <Row gutter={[16, 16]}>
                        {projectReports.map((report) => (
                          <Col key={report.id} xs={24} sm={12} md={8} lg={6}>
                            <div
                              onClick={() => navigate(`/project-photo-report/${report.id}`, { state: { report } })}
                              style={{
                                border: '1px solid #e0e0e0',
                                borderRadius: '8px',
                                padding: '16px',
                                cursor: 'pointer',
                                transition: 'all 0.3s',
                                background: 'white',
                                boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
                                height: '100%'
                              }}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)';
                                e.currentTarget.style.transform = 'translateY(-4px)';
                                e.currentTarget.style.borderColor = '#1890ff';
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.boxShadow = '0 2px 4px rgba(0,0,0,0.05)';
                                e.currentTarget.style.transform = 'translateY(0)';
                                e.currentTarget.style.borderColor = '#e0e0e0';
                              }}
                            >
                              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
                                <FileTextOutlined style={{ fontSize: '32px', color: '#1890ff' }} />
                                <Button
                                  shape="circle"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleOpenReportShare(report);
                                  }}
                                  style={{
                                    backgroundColor: '#f0f4f8',
                                    border: 'none',
                                    boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
                                    color: '#0a497b',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center'
                                  }}
                                  icon={<ShareAltOutlined style={{ fontSize: '16px' }} />}
                                />
                              </div>
                              <h4 style={{
                                margin: '0 0 8px 0',
                                fontSize: '16px',
                                fontWeight: '600',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap'
                              }}>
                                {report.title}
                              </h4>
                              <div style={{ fontSize: '13px', color: '#666', marginBottom: '4px' }}>
                                <strong>Layout:</strong> {report.photos_per_page || report.photosPerPage || 2} photos/page
                              </div>
                              <div style={{ fontSize: '13px', color: '#666', marginBottom: '4px' }}>
                                <strong>Images:</strong> {report.total_images || 0}
                              </div>
                              <div style={{ fontSize: '12px', color: '#999', marginTop: '8px' }}>
                                {new Date(report.created_at || report.createdAt).toLocaleDateString()}
                              </div>
                            </div>
                          </Col>
                        ))}
                      </Row>
                      {projectReports.length < reportsTotal && (
                        <div style={{ marginTop: '24px', textAlign: 'center' }}>
                          <Button
                            type="primary"
                            className="submitBtn"
                            size="large"
                            loading={loadingMoreReports}
                            onClick={() => {
                              const nextPage = Math.floor(projectReports.length / 15) + 1;
                              loadProjectReports(nextPage, true);
                            }}
                          >
                            Load More ({projectReports.length} of {reportsTotal})
                          </Button>
                        </div>
                      )}
                    </>
                  )}
                </div>
              </div>
            )}

            {reorderMode && switchedFromDateMode && (
              <div className="reorder-notice-banner">
                <div className="reorder-notice-content">
                  <div className="reorder-notice-icon-circle">
                    <InfoCircleOutlined />
                  </div>
                  <div className="reorder-notice-text">
                    <span className="reorder-notice-title">Switched to Custom Order</span>
                    <span className="reorder-notice-desc">
                      Reordering is enabled across all photos so you can arrange them freely between dates.
                    </span>
                  </div>
                </div>
                <button
                  type="button"
                  className="reorder-notice-close"
                  onClick={() => setSwitchedFromDateMode(false)}
                  title="Dismiss"
                >
                  <CloseOutlined style={{ fontSize: '12px' }} />
                </button>
              </div>
            )}

            <DndContext
              sensors={sensors}
              collisionDetection={closestCenter}
              onDragStart={handleDragStartDnd}
              onDragEnd={handleDragEndDnd}
            >
              {galleryViewMode === 'index' ? renderImagesByIndex() : renderImagesByDate(sortedObject)}
              <DragOverlay adjustScale={false}>
                {activeDragItem ? (
                  <div
                    style={{
                      width: '160px',
                      position: 'relative',
                      pointerEvents: 'none',
                      userSelect: 'none',
                    }}
                  >
                    {activeDragItem.isMultiple && activeDragItem.count > 1 ? (
                      <div style={{ position: 'relative', width: '100%', height: '120px' }}>
                        {/* Layer 3 (deepest background card, if 3+ photos) */}
                        {activeDragItem.count >= 3 && (
                          <div
                            style={{
                              position: 'absolute',
                              top: 0,
                              left: 0,
                              width: '100%',
                              height: '100%',
                              borderRadius: '8px',
                              background: '#f0f5ff',
                              border: '2px solid #69c0ff',
                              boxShadow: '0 6px 16px rgba(0,0,0,0.15)',
                              transform: 'translateX(14px) translateY(-4px) rotate(6deg)',
                              transformOrigin: 'bottom left',
                              zIndex: 1,
                              overflow: 'hidden',
                            }}
                          >
                            <img
                              src={activeDragItem.stackImages?.[2]?.image || activeDragItem.stackImages?.[2]?.image_url || placeholderIMage}
                              alt="card-back-2"
                              style={{ width: '100%', height: '100%', objectFit: 'cover', opacity: 0.8 }}
                            />
                          </div>
                        )}

                        {/* Layer 2 (middle background card) */}
                        <div
                          style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                            borderRadius: '8px',
                            background: '#e6f7ff',
                            border: '2px solid #40a9ff',
                            boxShadow: '0 8px 20px rgba(0,0,0,0.2)',
                            transform: 'translateX(7px) translateY(-2px) rotate(3deg)',
                            transformOrigin: 'bottom left',
                            zIndex: 2,
                            overflow: 'hidden',
                          }}
                        >
                          <img
                            src={activeDragItem.stackImages?.[1]?.image || activeDragItem.stackImages?.[1]?.image_url || placeholderIMage}
                            alt="card-back-1"
                            style={{ width: '100%', height: '100%', objectFit: 'cover', opacity: 0.9 }}
                          />
                        </div>

                        {/* Layer 1 (front top card) */}
                        <div
                          style={{
                            position: 'relative',
                            width: '100%',
                            height: '100%',
                            background: 'white',
                            borderRadius: '8px',
                            boxShadow: '0 14px 32px rgba(0,0,0,0.3)',
                            padding: '4px',
                            border: '2.5px solid #1890ff',
                            zIndex: 3,
                          }}
                        >
                          <img
                            src={activeDragItem.image?.image || activeDragItem.image?.image_url || placeholderIMage}
                            alt="dragging"
                            style={{
                              width: '100%',
                              height: '100%',
                              objectFit: 'cover',
                              borderRadius: '5px',
                              display: 'block'
                            }}
                          />
                          <div
                            style={{
                              position: 'absolute',
                              top: '-10px',
                              right: '-10px',
                              background: '#52c41a',
                              color: 'white',
                              borderRadius: '20px',
                              padding: '3px 10px',
                              fontSize: '12px',
                              fontWeight: '700',
                              boxShadow: '0 3px 8px rgba(0,0,0,0.25)',
                              border: '2px solid white',
                              letterSpacing: '0.3px',
                              zIndex: 10,
                            }}
                          >
                            {activeDragItem.count} Photos
                          </div>
                        </div>
                      </div>
                    ) : (
                      /* Single Card Drag Preview */
                      <div
                        style={{
                          width: '100%',
                          height: '120px',
                          background: 'white',
                          borderRadius: '8px',
                          boxShadow: '0 12px 32px rgba(0,0,0,0.25)',
                          padding: '4px',
                          border: '2px solid #1890ff',
                          position: 'relative',
                        }}
                      >
                        <img
                          src={activeDragItem.image?.image || activeDragItem.image?.image_url || placeholderIMage}
                          alt="dragging"
                          style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '5px', display: 'block' }}
                        />
                      </div>
                    )}
                  </div>
                ) : null}
              </DragOverlay>
            </DndContext>
            {/* Project Videos Section */}
            <div className="row mt-3 mb-4 video-tab">
              <div className="col-md-12">
                <h4 style={{ marginBottom: '16px', color: '#0a497b' }}>Project Videos</h4>
                {loadingVideos && projectVideos.length === 0 ? (
                  <div style={{ textAlign: 'center', padding: '40px 20px' }}>Loading videos...</div>
                ) : projectVideos.length === 0 ? (
                  <div style={{
                    textAlign: 'center',
                    padding: '40px 20px',
                    background: '#fafafa',
                    borderRadius: '8px',
                    border: '1px dashed #d9d9d9'
                  }}>
                    <VideoCameraOutlined style={{ fontSize: '48px', color: '#d9d9d9', marginBottom: '16px' }} />
                    <p style={{ color: '#888', fontSize: '16px', margin: 0 }}>No videos uploaded for this project yet.</p>
                    <Button
                      type="primary"
                      icon={<VideoCameraOutlined />}
                      style={{
                        marginTop: '16px',
                        background: '#0a497b',
                        borderColor: '#0a497b',
                        borderRadius: '50px',
                        fontWeight: '600',
                        height: '38px',
                        padding: '0 22px',
                        boxShadow: '0 2px 8px rgba(10, 73, 123, 0.25)'
                      }}
                      onClick={() => {
                        setUploadView('videos');
                        const uploadSection = document.getElementById('project-upload-section');
                        if (uploadSection) {
                          uploadSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
                        } else {
                          window.scrollTo({ top: 0, behavior: 'smooth' });
                        }
                        setTimeout(() => {
                          const videoInput = document.querySelector('input[type="file"][accept="video/*"]');
                          if (videoInput) {
                            videoInput.click();
                          }
                        }, 200);
                      }}
                    >
                      Upload Videos
                    </Button>
                  </div>
                ) : (
                  <>
                    <Row gutter={[16, 16]}>
                      {projectVideos.map((video) => (
                        <Col key={video.id} xs={24} sm={12} md={8} lg={6}>
                          <Card className="videocard-box"
                            hoverable
                            cover={
                              <div style={{ position: 'relative', height: '220px', background: '#000', overflow: 'hidden' }}>
                                <video
                                  src={`${video.source_url}#t=0.001`}
                                  poster={video.thumb_url}
                                  style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                  preload="metadata"
                                  muted
                                  onLoadedMetadata={(e) => {
                                    if (e.target.duration && !isNaN(e.target.duration)) {
                                      const duration = getVideoDuration(e.target);
                                      setProjectVideos(prev => prev.map(v =>
                                        v.id === video.id ? { ...v, duration } : v
                                      ));
                                    }
                                  }}
                                />
                                {video.duration && (
                                  <div style={{ zIndex: '2', position: 'absolute', bottom: '8px', right: '8px', background: '#0a497b', color: '#fff', padding: '2px 6px', borderRadius: '4px', fontSize: '12px' }}>
                                    {video.duration}
                                  </div>
                                )}
                                <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'rgba(0,0,0,0.3)' }}>
                                  <PlayCircleOutlined
                                    style={{ fontSize: '48px', color: '#fff', cursor: 'pointer' }}
                                    onClick={() => handleVideoPlay(video)}
                                  />
                                </div>
                              </div>
                            }
                            actions={[
                              <Tooltip title="Play Video">
                                <Button
                                  type="primary"
                                  shape="circle"
                                  icon={<PlayCircleOutlined />}
                                  onClick={() => handleVideoPlay(video)}
                                  style={{ backgroundColor: '#0a497b', borderColor: '#0a497b' }}
                                />
                              </Tooltip>,
                              <Tooltip title="Upload Time">
                                <div style={{
                                  display: 'inline-flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  gap: '6px',
                                  padding: '0 12px',
                                  height: '36px',
                                  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                  borderRadius: '18px',
                                  fontSize: '11px',
                                  fontWeight: '600',
                                  color: '#fff',
                                  boxShadow: '0 2px 8px rgba(102, 126, 234, 0.3)',
                                  margin: '0 4px',
                                  whiteSpace: 'nowrap'
                                }}>
                                  <FieldTimeOutlined style={{ fontSize: '13px' }} />
                                  <span>
                                    {video.created_at && getTimeAgo(video.created_at)}
                                  </span>
                                </div>
                              </Tooltip>,
                              <Tooltip title="Delete Video">
                                <Button
                                  type="primary"
                                  danger
                                  shape="circle"
                                  icon={<DeleteOutlined />}
                                  onClick={() => handleDeleteVideo(video.id)}
                                />
                              </Tooltip>,
                              <Tooltip title="Share Video">
                                <Button
                                  type="default"
                                  shape="circle"
                                  icon={<ShareAltOutlined />}
                                  onClick={() => handleShareClick('video', video)}
                                  style={{ color: '#0a497b', borderColor: '#0a497b' }}
                                />
                              </Tooltip>
                            ]}
                          >
                            <div className="project-detail-video-description" style={{ marginTop: '0px' }}>
                              {editingVideoDescriptionId === video.id ? (
                                <Input.TextArea
                                  style={{ border: "1px solid #75bdff" }}
                                  rows={3}
                                  value={videoDescriptionValue}
                                  autoFocus
                                  onChange={(e) => setVideoDescriptionValue(e.target.value)}
                                  onBlur={() => {
                                    handleChangeVideoDescription(videoDescriptionValue, video.description, video.id);
                                    setEditingVideoDescriptionId(null);
                                  }}
                                  onKeyDown={(e) => {
                                    if (e.key === "Escape") setEditingVideoDescriptionId(null);
                                  }}
                                />
                              ) : (
                                <Input.TextArea
                                  style={{ border: "1px solid #edecec", padding: "4px 4px", borderRadius: "2px", cursor: "pointer" }}
                                  onClick={() => {
                                    setEditingVideoDescriptionId(video.id);
                                    setVideoDescriptionValue(video.description || "");
                                  }}
                                  rows={2}
                                  value={video.description || "Click to add a description"}
                                  readOnly
                                />
                              )}
                            </div>
                          </Card>
                        </Col>
                      ))}
                    </Row>
                    {projectVideos.length < videosTotal && (
                      <div style={{ marginTop: '24px', textAlign: 'center' }}>
                        <Button
                          type="primary"
                          className="submitBtn"
                          size="large"
                          loading={loadingVideos}
                          onClick={() => {
                            const nextPage = Math.floor(projectVideos.length / 10) + 1;
                            fetchProjectVideos(nextPage, true);
                          }}
                        >
                          Load More ({projectVideos.length} of {videosTotal})
                        </Button>
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>

            {reorderMode && (
              <div className="reorder-floating-dock-wrapper">
                <div className="reorder-floating-dock">
                  <div className="reorder-dock-status">
                    {hasReorderChanges ? (
                      <span className="dock-status-chip changes">
                        <span className="pulse-dot"></span>
                        Unsaved changes
                      </span>
                    ) : (
                      <span className="dock-status-chip idle">
                        <DragOutlined style={{ marginRight: '6px' }} />
                        Drag to rearrange
                      </span>
                    )}
                  </div>

                  <div className="reorder-dock-actions">
                    <Button
                      type="primary"
                      icon={<CheckOutlined />}
                      className={`reorder-dock-btn save-btn ${hasReorderChanges ? 'has-changes' : 'disabled'}`}
                      onClick={handleReorderImages}
                      disabled={!hasReorderChanges}
                      loading={isSavingOrder}
                    >
                      Save Order
                    </Button>
                    <Button
                      icon={<CloseOutlined />}
                      className="reorder-dock-btn cancel-btn"
                      onClick={() => {
                        if (hasReorderChanges) {
                          Swal.fire({
                            title: "Discard changes?",
                            text: "You have unsaved changes in photo order. Are you sure you want to discard them?",
                            icon: "warning",
                            showCancelButton: true,
                            confirmButtonColor: "#d33",
                            cancelButtonColor: "#0a497b",
                            confirmButtonText: "Yes, discard changes",
                            cancelButtonText: "Keep editing"
                          }).then((result) => {
                            if (result.isConfirmed) {
                              setReorderMode(false);
                              setSelectedForReorder([]);
                              setSelectedImages([]);
                              setHasReorderChanges(false);
                              setSwitchedFromDateMode(false);
                              fetchProject();
                            }
                          });
                        } else {
                          setReorderMode(false);
                          setSelectedForReorder([]);
                          setSelectedImages([]);
                          setSwitchedFromDateMode(false);
                          fetchProject();
                        }
                      }}
                    >
                      Cancel
                    </Button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
        <Modal
          className="project-image-editor-model"
          closable={false}
          footer={false}
          centered
          width="100%"
          title={null}
          onCancel={() => handleModalClose()}
          onOk={() => handleModalClose()}
          bodyStyle={{ height: "100vh", overflow: "hidden", padding: 0 }}
          open={editorVisible}
          style={{ top: 0, padding: 0, margin: 0, maxWidth: "100vw" }}
        >
          <ImageEditorModal
            key={editorVisible ? Math.random() : null}
            imageUrl={selectedImage}
            originalImageUrl={selectedOriginalUrl}
            annotationsData={selectedAnnotations}
            project_id={project_id}
            image_id={imageId}
            setEditorVisible={setEditorVisible}
            setImageId={setImageId}
            setSelectedImage={setSelectedImage}
            fetchProject={fetchProject}
            editorVisible={editorVisible}
          />
        </Modal>

        <Modal
          className="photo-report-setting-model"
          title={
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', fontSize: '18px', fontWeight: '600' }}>
              <FileTextOutlined style={{ color: '#1890ff' }} />
              Create New Project Report
            </div>
          }
          open={reportModalVisible}
          width={680}
          onCancel={() => {
            setReportModalVisible(false);
            setReportTitle("");
            setPhotosPerPage(2);
            setLayoutOptions([]);
            setClaimNumber("");
          }}
          onOk={() => {
            // Load layout options when modal opens
            if (layoutOptions.length === 0) {
              dispatch(getLayoutOptions())
                .then((response) => {
                  setLayoutOptions(response.data || response || [2, 3, 4]);
                })
                .catch(() => {
                  setLayoutOptions([2, 3, 4]);
                });
            }
          }}
          afterOpenChange={(open) => {
            if (open && layoutOptions.length === 0) {
              dispatch(getLayoutOptions())
                .then((response) => {
                  setLayoutOptions(response.data || response || [2, 3, 4]);
                })
                .catch(() => {
                  setLayoutOptions([2, 3, 4]);
                });
            }
          }}
          footer={[
            <Button key="cancel" size="large" onClick={() => {
              setReportModalVisible(false);
              setReportTitle("");
              setPhotosPerPage(2);
              setLayoutOptions([]);
              setClaimNumber("");
            }}>
              Cancel
            </Button>,
            <Button
              key="create"
              type="primary"
              size="large"
              className="submitBtn"
              disabled={!reportTitle.trim() || creatingReport}
              loading={creatingReport}
              onClick={handleCreateReport}
              icon={<PlusCircleOutlined />}
            >
              Create Report
            </Button>,
          ]}
        >
          <div style={{ maxHeight: '65vh', overflowY: 'auto', padding: '8px 4px' }}>
            {/* Selected Images Info */}
            <div style={{ marginBottom: '20px', padding: '10px', background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', borderRadius: '8px', textAlign: 'center', boxShadow: '0 4px 12px rgba(102, 126, 234, 0.3)' }}>
              <div style={{ fontSize: '16px', color: '#fff', fontWeight: '600' }}>
                <PictureOutlined style={{ fontSize: '20px', marginRight: '8px' }} />
                {selectedImages.length} Image{selectedImages.length !== 1 ? 's' : ''} Selected
              </div>
            </div>

            {/* Report Title */}
            <div style={{ background: '#fff', padding: '20px', borderRadius: '8px', border: '1px solid #e8e8e8', marginBottom: '20px' }}>
              <Row gutter={16}>
                <Col xs={24} md={12}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '12px' }}>
                    <FileTextOutlined style={{ fontSize: '16px', color: '#1890ff' }} />
                    <label style={{ fontWeight: '600', fontSize: '15px', margin: 0 }}>
                      Report Title <span style={{ color: '#ff4d4f' }}>*</span>
                    </label>
                  </div>
                  <Input
                    className="formControl"
                    placeholder="Enter report title"
                    value={reportTitle}
                    onChange={(e) => setReportTitle(e.target.value)}
                    size="large"
                    status={!reportTitle.trim() && reportTitle !== '' ? 'error' : ''}
                  />
                </Col>
                <Col xs={24} md={12}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '12px' }}>
                    <NumberOutlined style={{ fontSize: '16px', color: '#fa541c' }} />
                    <label style={{ fontWeight: '600', fontSize: '15px', margin: 0 }}>
                      Claim Number
                    </label>
                  </div>
                  <Input
                    className="formControl"
                    placeholder="#123456"
                    value={claimNumber}
                    onChange={(e) => setClaimNumber(e.target.value)}
                    size="large"
                  />
                </Col>
              </Row>
            </div>

            {/* Photo Layout */}
            <div style={{ background: '#fafafa', padding: '20px', borderRadius: '8px', border: '1px solid #e8e8e8' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '16px' }}>
                <LayoutOutlined style={{ fontSize: '18px', color: '#1890ff' }} />
                <h3 style={{ margin: 0, fontSize: '16px', fontWeight: '600' }}>Photo Page Layout</h3>
              </div>
              <p style={{ color: '#8c8c8c', marginBottom: '16px', fontSize: '13px' }}>Select how many photos to display per page (you can change this anytime)</p>

              <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                {layoutOptions.length > 0 ? (
                  layoutOptions.map((option) => {
                    const layoutImages = {
                      2: 'https://fddatainsp.s3.us-east-2.amazonaws.com/wp-content/uploads/2025/12/11020031/layout-image-2693a6c0fa7ab9693a6c0fa7b4d.png',
                      3: 'https://fddatainsp.s3.us-east-2.amazonaws.com/wp-content/uploads/2025/12/11020024/layout-image-3693a6c08d58cd693a6c08d5974.png',
                      4: 'https://fddatainsp.s3.us-east-2.amazonaws.com/wp-content/uploads/2025/12/11020017/layout-image-4693a6c01df2f7693a6c01df389.png'
                    };
                    return (
                      <div
                        key={option}
                        onClick={() => setPhotosPerPage(option)}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                          padding: '14px 16px',
                          border: photosPerPage === option ? '2px solid #1890ff' : '1px solid #e0e0e0',
                          borderRadius: '8px',
                          cursor: 'pointer',
                          background: photosPerPage === option ? '#e6f7ff' : 'white',
                          transition: 'all 0.3s',
                          boxShadow: photosPerPage === option ? '0 2px 8px rgba(24, 144, 255, 0.2)' : 'none'
                        }}
                        onMouseEnter={(e) => {
                          if (photosPerPage !== option) {
                            e.currentTarget.style.borderColor = '#40a9ff';
                            e.currentTarget.style.boxShadow = '0 2px 8px rgba(64, 169, 255, 0.15)';
                          }
                        }}
                        onMouseLeave={(e) => {
                          if (photosPerPage !== option) {
                            e.currentTarget.style.borderColor = '#e0e0e0';
                            e.currentTarget.style.boxShadow = 'none';
                          }
                        }}
                      >
                        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                          <div style={{
                            width: '20px',
                            height: '20px',
                            borderRadius: '50%',
                            border: photosPerPage === option ? '6px solid #1890ff' : '2px solid #d9d9d9',
                            transition: 'all 0.3s'
                          }} />
                          <span style={{ fontSize: '15px', fontWeight: '500', color: photosPerPage === option ? '#1890ff' : '#262626' }}>
                            {option} Photos Per Page
                          </span>
                        </div>
                        <Image preview={false} src={layoutImages[option]} style={{ width: '70px', height: '70px', objectFit: 'contain', borderRadius: '4px' }} />
                      </div>
                    );
                  })
                ) : (
                  // Fallback options
                  <>
                    {[2, 3, 4].map((option) => {
                      const layoutImages = {
                        2: 'https://fddatainsp.s3.us-east-2.amazonaws.com/wp-content/uploads/2025/12/11020031/layout-image-2693a6c0fa7ab9693a6c0fa7b4d.png',
                        3: 'https://fddatainsp.s3.us-east-2.amazonaws.com/wp-content/uploads/2025/12/11020024/layout-image-3693a6c08d58cd693a6c08d5974.png',
                        4: 'https://fddatainsp.s3.us-east-2.amazonaws.com/wp-content/uploads/2025/12/11020017/layout-image-4693a6c01df2f7693a6c01df389.png'
                      };
                      return (
                        <div
                          key={option}
                          onClick={() => setPhotosPerPage(option)}
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            padding: '14px 16px',
                            border: photosPerPage === option ? '2px solid #1890ff' : '1px solid #e0e0e0',
                            borderRadius: '8px',
                            cursor: 'pointer',
                            background: photosPerPage === option ? '#e6f7ff' : 'white',
                            transition: 'all 0.3s',
                            boxShadow: photosPerPage === option ? '0 2px 8px rgba(24, 144, 255, 0.2)' : 'none'
                          }}
                          onMouseEnter={(e) => {
                            if (photosPerPage !== option) {
                              e.currentTarget.style.borderColor = '#40a9ff';
                              e.currentTarget.style.boxShadow = '0 2px 8px rgba(64, 169, 255, 0.15)';
                            }
                          }}
                          onMouseLeave={(e) => {
                            if (photosPerPage !== option) {
                              e.currentTarget.style.borderColor = '#e0e0e0';
                              e.currentTarget.style.boxShadow = 'none';
                            }
                          }}
                        >
                          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                            <div style={{
                              width: '20px',
                              height: '20px',
                              borderRadius: '50%',
                              border: photosPerPage === option ? '6px solid #1890ff' : '2px solid #d9d9d9',
                              transition: 'all 0.3s'
                            }} />
                            <span style={{ fontSize: '15px', fontWeight: '500', color: photosPerPage === option ? '#1890ff' : '#262626' }}>
                              {option} Photos Per Page
                            </span>
                          </div>
                          <Image preview={false} src={layoutImages[option]} style={{ width: '70px', height: '70px', objectFit: 'contain', borderRadius: '4px' }} />
                        </div>
                      );
                    })}
                  </>
                )}
              </div>
            </div>
          </div>
        </Modal>

        <Modal
          title="Video Preview"
          open={false} // Disabled native video modal to use FDCam Preview instead
          onCancel={() => setVideoModalVisible(false)}
          footer={null}
          width={800}
          destroyOnClose
        >
          {currentVideo && (
            <video
              src={currentVideo.source_url}
              controls
              autoPlay
              style={{ width: '100%', maxHeight: '70vh' }}
            />
          )}
        </Modal>

        <FDCamPreviewModal
          visible={fdcamPreviewVisible}
          onClose={() => setFdcamPreviewVisible(false)}
          mediaList={fdcamMediaList}
          initialIndex={fdcamInitialIndex}
          project={project}
          inspector={userDetails}
          mediaType={fdcamMediaType}
          onUpdateDescription={(newDesc, oldDesc, id, type) => {
            if (type === 'image') {
              handleChangedescription(newDesc, oldDesc, id);
            } else {
              handleChangeVideoDescription(newDesc, oldDesc, id);
            }
          }}
          onShare={(type, media) => handleShareClick(type === 'image' ? 'photo' : 'video', media)}
          onEditImage={handleEditImage}
          onDelete={(id, type) => {
            if (type === 'image') {
              deleteImagesInSequence([id], project.id).then(() => {
                message.success("Photo moved to Recycle Bin");
                fetchProject();
                loadTrashCount();
              });
            } else {
              handleDeleteVideo(id);
            }
          }}
        />

        {/* Share Media Modal */}
        <Modal
          title={shareData.title}
          visible={shareModalVisible}
          onCancel={() => setShareModalVisible(false)}
          footer={null}
          centered
          width={500}
          className="share-media-modal"
          closeIcon={<CloseOutlined style={{ fontSize: '18px' }} />}
        >
          <div style={{ padding: '0px 0' }}>
            <div className="share-settings-container" style={{ marginBottom: '25px', padding: '16px', background: '#f8f9fa', borderRadius: '12px', border: '1px solid #eee' }}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <span style={{ fontSize: '14px', fontWeight: '500', color: '#444' }}>
                  {shareData.type === 'document'
                    ? 'Include document details, date, and project info'
                    : shareData.type === 'video'
                    ? 'Include who, when, and where the video was taken'
                    : 'Include who, when, and where the photo was taken'}
                </span>
                <Switch
                  size="small"
                  checked={includeDetails}
                  onChange={(checked) => {
                    setIncludeDetails(checked);
                    // Regenerate tamper-proof token based on new checked state
                    const baseUrl = window.location.origin;
                    const newSecureId = getSecureId(shareData.rawId, checked);
                    const newUrl = `${baseUrl}/view-media/${shareData.type}/${newSecureId}?show_details=${checked ? '1' : '0'}`;
                    setShareData(prev => ({ ...prev, id: newSecureId, url: newUrl }));
                  }}
                />
              </div>
            </div>

            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '10px',
              background: '#f8f9fa',
              padding: '8px 12px',
              borderRadius: '8px',
              border: '1px solid #e9ecef',
              marginBottom: '24px'
            }}>
              <LinkOutlined style={{ color: '#ADB5BD' }} />
              <Input
                value={shareData.url}
                readOnly
                variant="borderless"
                style={{ background: 'transparent', flex: 1, padding: 0 }}
              />
              <Button
                type="link"
                onClick={copyToClipboard}
                style={{
                  fontWeight: '600',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '6px',
                  minWidth: '100px',
                  justifyContent: 'center',
                  background: isCopied ? '#f6ffed' : '#e6f7ff',
                  border: isCopied ? '1px solid #b7eb8f' : '1px solid #91d5ff',
                  borderRadius: '6px',
                  height: '32px',
                  fontSize: '13px',
                  color: isCopied ? '#52c41a' : '#1890ff'
                }}
              >
                {isCopied ? <><CheckOutlined /> Copied</> : <><CopyOutlined /> Copy Link</>}
              </Button>
            </div>

            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div style={{ display: 'flex', gap: '10px' }}>
                <Button
                  icon={<MailOutlined style={{ color: '#ea4335', fontSize: '16px' }} />}
                  href={`mailto:?subject=${encodeURIComponent(`Shared ${shareData.type} from Floor Detective`)}&body=${encodeURIComponent(`Hello,\n\nPlease check out this ${shareData.type} from our inspection:\n\n${shareData.url}`)}`}
                  style={{
                    borderRadius: '8px',
                    background: '#f8f9fa',
                    border: '1px solid #dee2e6',
                    height: '40px',
                    fontWeight: '600',
                    color: '#495057',
                    padding: '0 16px',
                    display: 'flex',
                    alignItems: 'center'
                  }}
                >
                  Email
                </Button>
                <Button
                  icon={<FacebookOutlined style={{ color: '#1877f2', fontSize: '16px' }} />}
                  style={{
                    borderRadius: '8px',
                    background: '#f8f9fa',
                    border: '1px solid #dee2e6',
                    height: '40px',
                    fontWeight: '600',
                    color: '#495057',
                    padding: '0 16px'
                  }}
                  onClick={() => window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareData.url)}`, '_blank')}
                >
                  Facebook
                </Button>
              </div>

              <Button
                type="primary"
                style={{
                  borderRadius: '8px',
                  background: '#1890ff',
                  height: '42px',
                  padding: '0 20px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  fontWeight: '600',
                  boxShadow: '0 2px 6px rgba(24, 144, 255, 0.25)',
                  border: 'none'
                }}
                onClick={() => window.open(shareData.type === 'document' ? (shareData.mediaUrl || shareData.url) : shareData.url, '_blank')}
              >
                <EyeOutlined style={{ fontSize: '16px' }} />
                <span style={{ marginLeft: '0px' }}>
                  View {shareData.type === 'photo' ? 'Photo' : shareData.type === 'document' ? 'Document' : 'Video'}
                </span>
              </Button>
            </div>
          </div>
        </Modal>
      </div>
      <ShareReportModal
        visible={reportShareModalVisible}
        onCancel={() => {
          setReportShareModalVisible(false);
          setSelectedReportToShare(null);
        }}
        shareLink={selectedReportToShare?.share_token ? `${window.location.origin}/shared-report/${selectedReportToShare.share_token}` : ''}
        isSyncing={syncingReportToken}
        onGenerateNewLink={async () => {
          if (!selectedReportToShare) return;
          const newToken = generateReportShareToken();
          setSyncingReportToken(true);
          try {
            await dispatch(updateReportShareSettings(selectedReportToShare.id, {
              share_token: newToken,
              share_token_expires_at: null
            }));
            setSelectedReportToShare({ ...selectedReportToShare, share_token: newToken });
            setProjectReports(prev => prev.map(r => r.id === selectedReportToShare.id ? { ...r, share_token: newToken } : r));
            message.success("New secure link generated and saved!");
          } catch (error) {
            message.error("Failed to update share link on server.");
          } finally {
            setSyncingReportToken(false);
          }
        }}
        onViewReport={() => {
          if (selectedReportToShare?.share_token) {
            window.open(`/shared-report/${selectedReportToShare.share_token}`, '_blank');
          }
        }}
        reportTitle={selectedReportToShare?.title}
      />

      {/* Project History Drawer */}
      <ProjectHistoryDrawer
        visible={historyDrawerVisible}
        onClose={() => setHistoryDrawerVisible(false)}
        projectId={project?.id}
        projectName={project?.name}
      />

      {/* Project Trash Modal */}
      <ProjectTrashModal
        visible={trashModalVisible}
        onClose={() => setTrashModalVisible(false)}
        projectId={project?.id || project_id}
        onRestored={() => {
          fetchProject();
          fetchProjectVideos();
          loadTrashCount();
        }}
      />

      {/* Project Document Upload Modal */}
      <ProjectDocumentUploadModal
        open={uploadDocModalVisible}
        onClose={() => setUploadDocModalVisible(false)}
        projectId={project?.id || project_id}
        existingDocumentsCount={documentsTotal}
        onSuccess={(result) => {
          if (Array.isArray(result)) {
            setProjectDocuments((prev) => [...result, ...prev]);
            setDocumentsTotal((prev) => prev + result.length);
          } else if (result) {
            setProjectDocuments((prev) => [result, ...prev]);
            setDocumentsTotal((prev) => prev + 1);
          }
          setShowDocuments(true);
          fetchProject();
        }}
      />
    </DndProvider>
  );
};

export default ProjectDetail;
